<template>
  <div>
    <div class="toggle-btn-container" style="text-align: center;">
      <span class="el-button is-round" :class="type==='line'?'el-button--primary':''" @click="type='line'">网上仲裁规则</span>
      <span class="el-button is-round" :class="type==='underLine'?'el-button--primary':''" @click="type='underLine'">仲裁规则</span>
    </div>
    <div v-if="type === 'line'">
      <p style="line-height: 150%">
        <br/>
      </p>
      <p style=";text-align:center;line-height:150%">
        <span style="line-height: 150%;font-size: 19px"><span>中国海事仲裁委员会网上仲裁规则</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span style="font-weight: 700;">第一章</span> <span
          style="font-weight: 700;">总则</span></span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第一条</span> <span>制定目的</span></span></strong>
      </p>
      <p style="line-height: 150%">
        <span
          style="line-height:150%;font-size:16px"><span>为以在线方式独立公正、高效经济地仲裁契约性或非契约性的经济纠纷，特制定本规则。本规则适用于</span></span><span
        style="line-height: 150%;font-size: 16px"><span>签订或履行行为部分或全部在互联网上完成的合同</span></span><span
        style="line-height: 150%;font-size: 16px"><span>争议</span></span><span style="line-height: 150%;font-size: 16px"><span>。</span></span>
      </p>
      <p style="line-height: 150%">
        <span><span style="line-height: 150%;font-size: 16px">&nbsp;</span></span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>二</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>本规则下列术语的含义</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）仲裁委员会：指中国海事仲裁委员会（原名中国国际贸易促进委员会海事仲裁委员会</span>)</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）《仲裁规则》</span>:指现行有效的《中国海事仲裁委员会仲裁规则》。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（三）《仲裁员名册》</span>:指现行有效的《中国海事仲裁委员会仲裁员名册》。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（四）网上仲裁平台：指仲裁委员会</span></span><span
        style="line-height: 150%;font-size: 16px"><span>指定</span></span><span style="line-height: 150%;font-size: 16px"><span>的、主要从事网上</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁</span></span><span style="line-height: 150%;font-size: 16px"><span>的专门平台。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（五）书面形式</span>:指合同书、信件和数据电文（包括电报、电传、传真、电子数据交换、电子邮件、即时电子通讯记录）等能够表现所载内容并可以随时调取查用的信息记载形式。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（六）电子数据：指基于计算机应用、通信和现代管理技术等电子化技术手段形成的包括文字、图形符号、数字、字母等的客观资料，体现的形式包括但不限于通过电子邮件、电子数据交换、网上聊天记录、博客、微博、手机短信、电子签名、域名等形成或存储在电子介质中的信息。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（</span></span><span
        style="line-height: 150%;font-size: 16px"><span>七</span></span><span
        style="line-height: 150%;font-size: 16px"><span>）电子签名</span>:指数据电文中以电子形式所含、所附用于识别签名人身份并表明签名人认可其中内容的数据。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height:150%;font-size:16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>三</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>规则的适用</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）本规则统一适用于仲裁委员会及</span></span><span
        style="line-height: 150%;font-size: 16px"><span>其</span></span><span
        style="line-height: 150%;font-size: 16px"><span>分会</span>/仲裁中心。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height:150%;font-size:16px"><span>（二）仲裁委员会受理的案件，当事人约定适用本规则的，适用本规则</span></span><span
        style="line-height:150%;font-size:16px"><span>。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（三）当事人约定将争议提交仲裁委员会网络</span>/网上仲裁的，或约定在仲裁委员会网上仲裁平台进行仲裁的，视为同意按照本规则进行仲裁。</span>
      </p>
      <p style="line-height: 150%">
        <span style="line-height:150%;font-size:16px"><span>（四）当事人约定按照本规则进行仲裁但未约定仲裁机构的，视为同意将争议提交仲裁委员会仲裁。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span
          style="line-height: 150%;font-size: 16px"><span>（五）本规则的规定与《仲裁规则》不一致的，以本规则的规定为准。本规则未尽事宜，适用《仲裁规则》。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>四</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>仲裁协议</span> </span></strong>
      </p>
      <p style=";line-height:150%">
        <span
          style="line-height:150%;font-size:16px"><span>（一）仲裁协议系指当事人在合同中约定的仲裁条款，或以其他方式达成的提交仲裁的书面协议。仲裁协议应当采取书面形式。</span></span>
      </p>
      <p style=";line-height:150%">
        <span
          style="line-height:150%;font-size:16px"><span>（二）仲裁委员会有权对仲裁协议的存在、效力以及仲裁案件的管辖权做出决定。如有必要，仲裁委员会也可以授权仲裁庭</span></span><span
        style="line-height:150%;font-size:16px"><span>作</span></span><span
        style="line-height:150%;font-size:16px"><span>出管辖权决定。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height:150%;font-size:16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第五条</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px">&nbsp;</span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>管辖权和主体资格异议</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（一）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>当事人对仲裁协议的存在、效力或仲裁案件的管辖权有异议的，</span></span><span
        style="line-height: 150%;font-size: 16px"><span>或对主体资格有异议的，</span></span><span
        style="line-height: 150%;font-size: 16px"><span>应当在首次答辩期限届满</span></span><span
        style="line-height: 150%;font-size: 16px"><span>前通过网上仲裁平台</span></span><span
        style="line-height: 150%;font-size: 16px"><span>提出。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（二）当事人提出管辖权及</span>/或主体资格异议不影响仲裁程序继续进行。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height:150%;font-size:16px"><span>（三）一方当事人知道或理应知道仲裁协议的约定存在全部或部分无效的情形、仲裁协议约定的任何条款或情事未被遵守，在仲裁程序中不对上述情况及时地、明示地以书面形式提出异议的，视为放弃其提出异议的权利。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height:150%;font-size:16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第六条</span>&nbsp;</span></strong><strong><span
        style="line-height: 150%;font-size: 16px">&nbsp;</span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>身份认证</span></span></strong>
      </p>
      <p style=";line-height:150%;background:rgb(255,255,255)">
        <span style="line-height:150%;font-size:16px"><span>当事人及其代理人使用网上仲裁平台实施仲裁行为的，应当通过证件证照比对、生物特征识别或者其他法律认可的在线方式等完成身份认证，并取得登录网上仲裁平台的专用账号。</span></span>
      </p>
      <p style=";line-height:150%;background:rgb(255,255,255)">
        <span style="line-height:150%;font-size:16px"><span>使用专用账号登录网上仲裁平台所作出的行为，视为被认证人本人行为，但因网上仲裁平台技术原因导致系统错误，或者被认证人能够证明网上仲裁平台账号被盗用的除外。</span></span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>七</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>仲裁地</span></span></strong><span
        style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <span
          style="line-height: 150%;font-size: 16px"><span>当事人对仲裁地有约定的，从其约定。当事人未作约定或约定不明的，以仲裁委员会所在地为仲裁地。仲裁裁决视为在仲裁地作出。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>八</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>信息安全</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁委员会为当事人、仲裁庭和仲裁委员会之间案件数据的在线传输提供必要的安全保障，并采取为案件数据信息加密的形式为案件信息保密。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（二）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>因不可抗力、计算机病毒、黑客攻击、系统不稳定、网络故障等非由仲裁委员会或仲裁</span></span><span
        style="line-height: 150%;font-size: 16px"><span>员</span></span><span
        style="line-height: 150%;font-size: 16px"><span>故意情形导致损失的，仲裁员、仲裁委员会及其相关人员不承担责任。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%;background:rgb(255,255,255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;&nbsp;</span><strong><span
        style="line-height: 150%;font-size: 16px"><span style="font-weight: 700;">第二章</span> <span
        style="font-weight: 700;">文件提交与送达</span></span></strong>
      </p>
      <p style=";text-align:center;line-height:150%;background:rgb(255,255,255)">
        <span style=";;line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span><span
        style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>九</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>文件提交</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（一）当事人应当将在线电子数据上传、导入网上仲裁平台，或将线下证据通过扫描、翻拍、转录等方式进行电子化处理后上传至网上仲裁平台。</span></span>
      </p>
      <p><span style="line-height: 150%;font-size: 16px"><span>（二）文件成功上传至网上仲裁平台的时间视为文件提交时间。</span></span></p>
      <p><span
        style="line-height: 150%;font-size: 16px"><span>（三）当事人应当保留提交的电子版文件及上传记录，以记载有关文件发送的具体事实和情况，供其他当事人及仲裁庭查阅。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style=";;line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>电子送达地址</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）当事人</span></span><span
        style="line-height: 150%;font-size: 16px"><span>可以</span></span><span style="line-height: 150%;font-size: 16px"><span>在仲裁协议或合同中约定网上仲裁平台、</span></span><span
        style="line-height: 150%;font-size: 16px"><span>移动通信</span></span><span
        style="line-height: 150%;font-size: 16px"><span>号码、传真、电子邮件或即时通讯账号等一种或多种联系方式，作为其电子送达地址</span></span><span
        style="line-height: 150%;font-size: 16px"><span>。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（</span></span><span
        style="line-height: 150%;font-size: 16px"><span>二</span></span><span
        style="line-height: 150%;font-size: 16px"><span>）当事人未约定也未向仲裁委员会仲裁院确认的，其在网络交易中使用的或网站注册、企业登记注册的包括但不限于电子邮箱或移动通信号码，作为其电子送达地址。</span></span>
      </p>
      <p>
        <span style="line-height: 150%;font-size: 16px">（三）当事人在网上仲裁过程中变更电子送达地址，应当及时通知仲裁委员会仲裁院。</span>
      </p>
      <p>
        <span style="line-height: 150%;font-size: 16px"><span>（</span></span><span
        style="line-height: 150%;font-size: 16px"><span>四</span></span><span
        style="line-height: 150%;font-size: 16px"><span>）当事人应确保约定或确认的电子送达地址合法有效，并自行承担因地址错误或仲裁地法律限制等原因造成的无法送达风险。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style=";;line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>十一</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>电子送达</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（一）仲裁委员会仲裁院通过网上仲裁平台、</span></span><span
        style="line-height: 150%;font-size: 16px"><span>移动通信</span></span><span
        style="line-height: 150%;font-size: 16px"><span>号码、传真、电子邮件、即时通讯账号等一种或多种电子方式进行送达。</span></span><span
        style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（二）仲裁委员会仲裁院向当事人发送的仲裁文件，有以下情形之一的，视为送达：</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">1</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁委员会仲裁院将文件发送至当事人约定的电子送达地址；</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">2</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁委员会仲裁院向当事人发出在网上仲裁平台查看或下载文件的通知；</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">3.</span><span style="line-height: 150%;font-size: 16px"><span>受送达人的媒介系统反馈受送达人已阅知，或有其他证据证明受送达人已经收悉的。</span></span>
      </p>
      <p>
        <span style="line-height: 150%;font-size: 16px">（三）第(一)款送达方式对应的系统显示发送成功的日期即为送达日期，但受送达人证明到达其媒介系统的日期与仲裁委员会对应系统显示发送成功的日期不一致的，以受送达人证明到达其媒介系统的日期为准。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span style="font-weight: 700;">第三章</span> <span
          style="font-weight: 700;">仲裁程序</span></span></strong>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span
          style="line-height: 150%;font-size: 16px"><span>第一节</span> <span>仲裁申请、答辩、反请求</span></span></strong>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>二</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>申请仲裁</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style=";;line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span><span
        style="line-height: 150%;font-size: 16px"><span>申请人提出仲裁申请应当符合下列要求：</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（一）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>申请人</span></span><span
        style="line-height: 150%;font-size: 16px"><span>向仲裁委员会提交仲裁申请书。仲裁申请书应写明：</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">1</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>申请人和被申请人的名称、住所</span></span><span
        style="line-height: 150%;font-size: 16px"><span>及其</span></span><span style="line-height: 150%;font-size: 16px"><span>电子送达地址；</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">2</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>申请仲裁所依据的仲裁协议；</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">3</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁请求；</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">4</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>案情和争议要点；</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">5</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁请求所依据的事实和理由。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（二）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>附具仲裁请求所依据事实的证明文件。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（三）附具当事人主体资格证明文件。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（四）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>按照仲裁委员会制定的《</span></span><span
        style="line-height: 150%;font-size: 16px"><span>中国海事仲裁委员会</span></span><span
        style="line-height: 150%;font-size: 16px"><span>网上仲裁费用表》（附件）的规定预缴仲裁费。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>三</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span></span></strong><span
        style="line-height: 150%;font-size: 16px">&nbsp; </span><strong><span style="line-height: 150%;font-size: 16px"><span>受理</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>仲裁委员会仲裁院认为申请人申请仲裁的手续完备的，应向双方当事人发出受理案件的仲裁通知，以及本规则、《仲裁规则》和《仲裁员名册》。</span></span>
      </p>
      <p style="text-indent: 32px;line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>四</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>答辩</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（一）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>除非当事人另有约定，被申请人应当在收到仲裁通知后</span>10</span><span
        style="line-height: 150%;font-size: 16px"><span>天</span></span><span
        style="line-height: 150%;font-size: 16px"><span>内提交答辩书和</span></span><span
        style="line-height: 150%;font-size: 16px"><span>相</span></span><span
        style="line-height: 150%;font-size: 16px"><span>关证据。答辩书应当包括下列内容：</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">1</span><span style="line-height: 150%;font-size: 16px">.被申请人的名称、住所及其电子送达地址；</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">2.对仲裁申请</span><span
        style="line-height: 150%;font-size: 16px"><span>书</span></span><span
        style="line-height: 150%;font-size: 16px"><span>的答辩及所依据的事实和理由；</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">3.答辩所依据的证明文件；</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">4.被申请人主体资格证明文件。</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（二）被申请人未提交答辩书不影响仲裁程序继续进行。</span></span>
      </p>
      <p style="text-indent: 24px;line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>五</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>反请求</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）被申请人</span></span><span
        style="line-height: 150%;font-size: 16px"><span>如有</span></span><span style="line-height: 150%;font-size: 16px"><span>反请求，应当自收到仲裁通知后</span>10</span><span
        style="line-height: 150%;font-size: 16px"><span>天</span></span><span
        style="line-height: 150%;font-size: 16px"><span>内提交反请求申请书和相关证据。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（</span></span><span
        style="line-height: 150%;font-size: 16px"><span>二</span></span><span
        style="line-height: 150%;font-size: 16px"><span>）被申请人提出反请求，应按照仲裁委员会制定的《中国海事仲裁委员会网上仲裁</span></span><span
        style="line-height: 150%;font-size: 16px"><span>费用</span></span><span style="line-height: 150%;font-size: 16px"><span>表》</span></span><span
        style="line-height: 150%;font-size: 16px"><span>（附件）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>在规定的时间内预缴仲裁费。被申请人未按期缴纳反请求仲裁费的，视同未提出反请求申请。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（</span></span><span
        style="line-height: 150%;font-size: 16px"><span>三</span></span><span
        style="line-height: 150%;font-size: 16px"><span>）仲裁委员会仲裁院认为被申请人提出反请求的手续完备的，应向双方当事人发出反请求受理通知。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（四）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>申请人应当在收到</span></span><span
        style="line-height: 150%;font-size: 16px"><span>反请求受理通知后</span></span><span
        style="line-height: 150%;font-size: 16px">10</span><span
        style="line-height: 150%;font-size: 16px"><span>天</span></span><span
        style="line-height: 150%;font-size: 16px"><span>内</span></span><span
        style="line-height: 150%;font-size: 16px"><span>针对被申请人的反请求</span></span><span
        style="line-height: 150%;font-size: 16px"><span>提交答辩</span></span><span
        style="line-height: 150%;font-size: 16px"><span>书和相关证据</span></span><span
        style="line-height: 150%;font-size: 16px"><span>。</span></span><span
        style="line-height: 150%;font-size: 16px"><span>申请人对被申请人的反请求未提交答辩书不影响仲裁程序继续进行。</span></span>
      </p>
      <p style="text-indent: 24px;line-height: 150%;background: rgb(255, 255, 255)">
        <span style="text-decoration:line-through;"><span style="line-height: 150%;font-size: 16px">&nbsp;</span></span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第二节</span> </span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>仲裁员及</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>仲裁庭</span></span></strong>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>六</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>仲裁员名册</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span><span
        style="line-height: 150%;font-size: 16px"><span>当事人</span></span><span
        style="line-height: 150%;font-size: 16px"><span>应</span></span><span
        style="line-height: 150%;font-size: 16px"><span>从</span></span><span
        style="line-height: 150%;font-size: 16px"><span>《</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁员名册</span></span><span
        style="line-height: 150%;font-size: 16px"><span>》</span></span><span
        style="line-height: 150%;font-size: 16px"><span>中选定仲裁员。当事人约定在</span></span><span
        style="line-height: 150%;font-size: 16px"><span>《仲裁员名册》</span></span><span
        style="line-height: 150%;font-size: 16px"><span>之外选定仲裁员的，当事人选定的或根据当事人之间的协议指定的人士经仲裁委员会主任依法确认后可以担任仲裁员。确认与否，不附具理由。由仲裁委员会主任指定仲裁员时，除非当事人另有约定，仲裁委员会主任在</span></span><span
        style="line-height: 150%;font-size: 16px"><span>《</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁员名册</span></span><span
        style="line-height: 150%;font-size: 16px"><span>》</span></span><span
        style="line-height: 150%;font-size: 16px"><span>中指定。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>十七</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>仲裁庭的人数和组成</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span
          style="line-height: 150%;font-size: 16px"><span>（一）除非当事人另有约定，凡争议金额不超过人民币两百万元的，仲裁庭由一名仲裁员组成。双方当事人应自收到仲裁通知后</span></span><span
        style="line-height: 150%;font-size: 16px">5天</span><span style="line-height: 150%;font-size: 16px"><span>内共同选定或共同委托仲裁委员会主任指定</span></span><span
        style="line-height: 150%;font-size: 16px"><span>一名</span></span><span style="line-height: 150%;font-size: 16px"><span>仲裁员，逾期未能共同选定或委托仲裁委员会主任指定的，由仲裁委员会主任指定。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>仲裁请求的变更或反请求的提出不影响仲裁程序的进行。经变更的仲裁请求或反请求所涉争议金额分别超过人民币两百万元的，除非当事人另有约定或仲裁庭认为有必要，案件继续由独任仲裁员审理。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）除非当事人另有约定，</span></span><span
        style="line-height: 150%;font-size: 16px"><span>凡</span></span><span
        style="line-height: 150%;font-size: 16px"><span>争议金额</span></span><span
        style="line-height: 150%;font-size: 16px"><span>超过</span></span><span style="line-height: 150%;font-size: 16px"><span>人民币两百万元的，仲裁庭由三名仲裁员组成。双方当事人应自收到仲裁通知后</span></span><span
        style="line-height: 150%;font-size: 16px">5天</span><span
        style="line-height: 150%;font-size: 16px"><span>内各自选定</span></span><span
        style="line-height: 150%;font-size: 16px"><span>或委托仲裁委员会主任指定一名仲裁员</span></span><span
        style="line-height: 150%;font-size: 16px"><span>，并共同选定或共同委托仲裁委员会主任指定一名首席仲裁员，逾期未选定</span></span><span
        style="line-height: 150%;font-size: 16px"><span>或委托仲裁委员会主任指定</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁员</span></span><span
        style="line-height: 150%;font-size: 16px"><span>的和</span>/或</span><span
        style="line-height: 150%;font-size: 16px"><span>未共同选定或委托仲裁委员会主任指定首席仲裁员的，由仲裁委员会主任指定。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>仲裁案件有两个或两个以上申请人及</span>/或被申请人的，申请人之间及/或被申请人之间应当在上述期限内协商各自共同选定或各自共同委托仲裁委员会主任指定一名仲裁员。</span><span
        style="line-height: 150%;font-size: 16px"><span>如果申请人方及</span>/或被申请人方未能在上述规定的期限共同选定或各方共同委托仲裁委员会主任指定一名仲裁员,则由仲裁委员会主任指定仲裁庭三名仲裁员,并从中确定一人担任首席仲裁员。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第十八条</span> <span>披露</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span
          style="line-height: 150%;font-size: 16px"><span>被选定或被指定的仲裁员应签署声明书，向仲裁委员会书面披露可能引起对其公正性或独立性产生合理怀疑的任何事实或情况。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>十九</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>仲裁员的回避</span> </span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（一）</span></span><span
        style="line-height: 150%;font-size: 16px">&nbsp;</span><span style="line-height: 150%;font-size: 16px"><span>当事人以仲裁员披露的信息为由要求该仲裁员回避的，应自收到仲裁员披露信息后</span>5</span><span
        style="line-height: 150%;font-size: 16px"><span>天</span></span><span
        style="line-height: 150%;font-size: 16px"><span>内提出。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）对仲裁员的回避请求应在收到组庭通知后</span>5</span><span
        style="line-height: 150%;font-size: 16px"><span>天</span></span><span
        style="line-height: 150%;font-size: 16px"><span>内提出；在此之后得知要求回避事由的，可以在得知回避事由后</span>5</span><span
        style="line-height: 150%;font-size: 16px"><span>天</span></span><span
        style="line-height: 150%;font-size: 16px"><span>内提出。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（三）当事人在得知回避事由后，应当根据前款规定的时间及时提出书面回避请求。未在规定期限内及时提出的视为放弃其提出异议的权利。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第三节</span> <span>审理</span></span></strong>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第二十条</span> <span>审理方式</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（一）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>除非当事人另有约定或仲裁庭另有决定，</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁庭对网</span></span><span
        style="line-height: 150%;font-size: 16px"><span>上</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁案件</span></span><span
        style="line-height: 150%;font-size: 16px"><span>进行书面审理</span></span><span
        style="line-height: 150%;font-size: 16px"><span>。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（二）仲裁庭认为必要时，可以通过网络视频庭审、电话会议等适当的方式审理案件，也可以决定在线下开庭，但其它环节仍在线上进行。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（三）按照本条第（二）款规定</span></span><span
        style="line-height: 150%;font-size: 16px"><span>的方式</span></span><span
        style="line-height: 150%;font-size: 16px"><span>开庭审理的案件，应不迟于开庭前</span>5</span><span
        style="line-height: 150%;font-size: 16px"><span>天</span></span><span
        style="line-height: 150%;font-size: 16px"><span>通知双方当事人。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（四）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁庭</span></span><span
        style="line-height: 150%;font-size: 16px"><span>以第（二）款方式开庭</span></span><span
        style="line-height: 150%;font-size: 16px"><span>审理的案件，可以运用语音识别技术同步生成庭审记录，也可以通过人工方式完成庭审记录。庭审记录以在线方式核对确认后，与书面笔录具有同等法律效力。</span></span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="text-decoration:line-through;"><span style="line-height: 150%;font-size: 16px">&nbsp;</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%;background:rgb(255,255,255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>四</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>节</span> <span>证</span> <span>据</span></span></strong>
      </p>
      <p style=";text-align:center;line-height:150%;background:rgb(255,255,255)">
        <span style=";;line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第二十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>一</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px">&nbsp;</span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>举证</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height:150%;font-size:16px"><span>（一）当事人应</span></span><span
        style="line-height:150%;font-size:16px"><span>在仲裁通知要求的期限内</span></span><span
        style="line-height:150%;font-size:16px"><span>对其申请、答辩和反请求所依据的事实提供证据加以证明。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>当事人提交的证据可以是以电子、光学、磁或类似手段生成、发送、接收或储存的电子证据。</span></span><span
        style="line-height: 150%;font-size: 16px"><span>对书证、物证、视听资料、鉴定意见及勘验笔录等证据，当事人可以如实转换成电子数据后提交，也可以在征得仲裁委员会仲裁院或仲裁庭的同意后采用或辅助采用邮寄和特快专递等其他方式提交证据。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第二十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>二</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>证据调取</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（一）仲裁庭可以就案件涉及的相关问题向</span></span><span
        style="line-height: 150%;font-size: 16px"><span>电子商务平台提供者、</span></span><span
        style="line-height: 150%;font-size: 16px"><span>网络服务提供商、物流配送公司、第三方支付平台、电子认证服务提供者</span></span><span
        style="line-height: 150%;font-size: 16px"><span>以及相关国家机关</span></span><span
        style="line-height: 150%;font-size: 16px"><span>等调查事实，收集证据。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>（二）仲裁庭调取的证据，应当交由双方当事人质证。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="text-decoration:line-through;"><span style="line-height: 150%;font-size: 16px">&nbsp;</span></span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第二十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>三</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>电子数据的认定</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）审查电子数据的真实性，仲裁庭</span></span><span
        style="line-height: 150%;font-size: 16px"><span>应当</span></span><span style="line-height: 150%;font-size: 16px"><span>考虑以下因素：</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">1</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>生成、储存或传递电子数据方法的可靠性；</span> </span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">2</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>保持内容完整性方法的可靠性；</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">3</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>用以鉴别发件人方法的可靠性；</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">4</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>其他相关因素。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）采用如下任一方式保障的电子数据</span></span><span
        style="line-height: 150%;font-size: 16px"><span>，仲裁庭应当确认</span></span><span
        style="line-height: 150%;font-size: 16px"><span>：</span></span>
      </p>
      <p style=";text-autospace:none;line-height:150%">
        <span style="line-height: 150%;font-size: 16px">1</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>电子数据生成时即向公证机构申请公证；</span></span>
      </p>
      <p style=";text-autospace:none;line-height:150%">
        <span style="line-height: 150%;font-size: 16px">2</span><span style="line-height: 150%;font-size: 16px">.当事人提交的电子数据，通过电子签名、可信时间戳、哈希值校验、区块链等证据收集、固定和防篡改的技术手段或者通过电子取证存证平台认证，能够证明其真实性的；</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">3</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>其他能够保证自形成时起，内容保持完整、未被更改的电子数据。但在数据电文上增加背书以及数据交换、储存和显示过程中发生的形式变化不影响数据电文的完整性。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（三）当事人可以采用可靠的电子签名，可靠的电子签名与手写签名或盖章具有同等的法律效力。可靠的电子签名需同时满足如下条件：</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">1</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>电子签名制作数据用于电子签名时，属于电子签名人专有；</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">2</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>签署时电子签名制作数据仅由电子签名人控制；</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">3</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>签署后对电子签名的任何改动能够被发现；</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">4</span><span style="line-height: 150%;font-size: 16px">.</span><span
        style="line-height: 150%;font-size: 16px"><span>签署后对数据电文内容和形式的任何改动能够被发现。</span></span>
      </p>
      <p style=";line-height:150%">
        <span
          style="line-height: 150%;font-size: 16px"><span>经依法设立的第三方电子认证机构认证的电子签名视为可靠的电子签名，当事人可以选择使用符合其约定的可靠条件的电子签名。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（四）仲裁庭应当全面、客观地审核电子数据，依据相关法律规定，参照司法解释，结合网络交易习惯，运用逻辑推理和日常生活经验法则等，对电子数据进行综合认定。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第二十四条</span> <span>质证</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span
          style="line-height: 150%;font-size: 16px"><span>（一）通过网络视频庭审、线下开庭等方式开庭审理的案件，证据应在开庭时出示，当事人可以质证。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）对于书面审理的案件的证据材料，或对于开庭后提交的证据材料，可以进行书面质证；书面质证时，当事人应在规定期限内提交书面质证意见。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>五</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>节</span> <span>裁</span> <span>决</span></span></strong>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>第二十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>五</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>裁决作出期限</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>除非当事人另有约定，仲裁庭应当在组庭后</span>2个月内作出裁决</span><span
        style="line-height: 150%;font-size: 16px"><span>书</span></span><span
        style="line-height: 150%;font-size: 16px"><span>。</span></span><span
        style="line-height: 150%;font-size: 16px"><span>经</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁庭</span></span><span
        style="line-height: 150%;font-size: 16px"><span>请求</span></span><span style="line-height: 150%;font-size: 16px"><span>，仲裁委员会</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁院院长</span></span><span
        style="line-height: 150%;font-size: 16px"><span>认为确有正当理由和必要的，可以延长该期限。</span></span>
      </p>
      <p style="text-indent: 24px;line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第二十</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>六</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span></span></strong><span
        style="line-height: 150%;font-size: 16px">&nbsp;</span><strong><span
        style="line-height: 150%;font-size: 16px"><span>裁决书核阅</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>仲裁庭应当在签署裁决书前将裁决书草案提交仲裁委员会核阅。在不影响仲裁庭独立裁决的情况下，仲裁委员会可以就裁决书的有关问题提请仲裁</span></span><span
        style="line-height: 150%;font-size: 16px"><span>庭</span></span><span
        style="line-height: 150%;font-size: 16px"><span>注意。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>二十七</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>结案文书</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）裁决书由仲裁员电子签名，并加盖</span>“中国海事仲裁委员会”电子印章。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）裁决书电子版送达至当事人的电子送达地址即视为送达。应当事人</span></span><span
        style="line-height: 150%;font-size: 16px"><span>书面</span></span><span style="line-height: 150%;font-size: 16px"><span>要求，仲裁委员会仲裁院</span></span><span
        style="line-height: 150%;font-size: 16px"><span>应当</span></span><span style="line-height: 150%;font-size: 16px"><span>向当事人发出纸质结案文书。</span></span>
      </p>
      <p style="text-indent:16px;line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>二十八</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>电子卷宗</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>仲裁委员会利用网</span></span><span
        style="line-height: 150%;font-size: 16px"><span>上</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁平台随案同步生成电子卷宗，形成电子档案。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>六节</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px">&nbsp;<span>程序转换</span></span></strong>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style="line-height: 150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第二十九条</span> <span>程序转换</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span
          style="line-height: 150%;font-size: 16px"><span>（一）以下情况，仲裁庭或仲裁委员会仲裁院有权将仲裁程序变更为线下方式，按照《仲裁规则》的规定继续进行仲裁程序：</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">1.因当事人原因导致本规则规定的网上仲裁程序无法继续进行的；</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">2.当事人对以电子数据形式提交的证据真实性存在争议，而仲裁庭无法通过在线方式予以认定的；</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">3.双方当事人一致同意的；</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">4.其他仲裁庭或仲裁委员会仲裁院认为必要的情形。</span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>若仲裁程序变更为线下方式继续进行，则仲裁委员会有权向当事人额外收取因仲裁程序转线下产生的合理费用。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（三）若仲裁程序变更为线下方式继续进行，在仲裁庭组成之前，由仲裁委员会仲裁院就程序的进行作出决定，仲裁庭组成之后，由仲裁庭就程序的进行作出决定。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span style="font-weight: 700;">第四章</span> <span
          style="font-weight: 700;">快速程序</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第三十条</span> <span>适用范围</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>除非当事人另有约定，凡争议金额不超过人民币</span></span><span
        style="line-height: 150%;font-size: 16px"><span>五</span></span><span
        style="line-height: 150%;font-size: 16px"><span>十万元的，适用快速程序。争议金额超过人民币</span></span><span
        style="line-height: 150%;font-size: 16px"><span>五</span></span><span
        style="line-height: 150%;font-size: 16px"><span>十万元，</span></span><span
        style="line-height: 150%;font-size: 16px"><span>但</span></span><span
        style="line-height: 150%;font-size: 16px"><span>经</span></span><span
        style="line-height: 150%;font-size: 16px"><span>当事人共同约定或经</span></span><span
        style="line-height: 150%;font-size: 16px"><span>一方当事人书面申请并征得另一方当事人书面同意的，适用快速程序。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁请求的变更或反请求的提出不影响快速程序的继续进行。经变更的仲裁请求或反请求所涉争议金额分别超过人民币</span></span><span
        style="line-height: 150%;font-size: 16px"><span>五</span></span><span
        style="line-height: 150%;font-size: 16px"><span>十万元的，除非当事人</span></span><span
        style="line-height: 150%;font-size: 16px"><span>另有</span></span><span style="line-height: 150%;font-size: 16px"><span>约定或仲裁庭认为有必要，案件继续适用快速程序。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（三）</span></span><span
        style="line-height: 150%;font-size: 16px"><span>本章未规定的事项，适用本规则其他各章的有关规定</span></span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>三十一</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> </span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>仲裁庭的组成</span></span></strong>
      </p>
      <p style="margin-bottom:0;line-height:150%;background:rgb(255,255,255)">
        <span style="line-height: 150%;font-size: 16px"><span>当事人应在收到仲裁通知后</span></span><span
        style="line-height: 150%;font-size: 16px">3天</span><span style="line-height: 150%;font-size: 16px"><span>内共同选定或共同委托</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁委员</span></span><span
        style="line-height: 150%;font-size: 16px"><span>会主任指定一名仲裁员组成仲裁庭。</span></span>
      </p>
      <p style="margin-bottom:0;line-height:150%;background:rgb(255,255,255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第三十二条</span> <span>仲裁员的回避</span></span></strong>
      </p>
      <p style="margin-bottom:0;line-height:150%;background:rgb(255,255,255)">
        <span
          style="line-height: 150%;font-size: 16px"><span>（一）</span> <span>当事人以仲裁员披露的信息为由要求该仲裁员回避的，应自收到仲裁员披露信息后</span></span><span
        style="line-height: 150%;font-size: 16px">3</span><span
        style="line-height: 150%;font-size: 16px"><span>天内提出。</span></span>
      </p>
      <p style="margin-bottom:0;line-height:150%;background:rgb(255,255,255)">
        <span style="line-height: 150%;font-size: 16px"><span>（二）对仲裁员的回避请求应在收到组庭通知后</span></span><span
        style="line-height: 150%;font-size: 16px">3</span><span style="line-height: 150%;font-size: 16px"><span>天内提出；在此之后得知要求回避事由的，可以在得知回避事由后</span></span><span
        style="line-height: 150%;font-size: 16px">3</span><span
        style="line-height: 150%;font-size: 16px"><span>天内提出。</span></span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px">&nbsp;</span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>三十三</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>答辩</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span><span
        style="line-height: 150%;font-size: 16px"><span>被申请人应当自收到仲裁通知后</span>5</span><span
        style="line-height: 150%;font-size: 16px"><span>天</span></span><span
        style="line-height: 150%;font-size: 16px"><span>内</span></span><span
        style="line-height: 150%;font-size: 16px"><span>提交答辩书和相关证据</span></span><span
        style="line-height: 150%;font-size: 16px"><span>。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style=";;line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>三十四</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>反请求</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>被申请人如有反请求，应当自收到仲裁通知后</span></span><span
        style="line-height: 150%;font-size: 16px">5</span><span style="line-height: 150%;font-size: 16px"><span>天内提交反请求申请书和相关证据。</span></span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height: 150%;font-size: 16px"><span>申请人应当在收到反请求受理通知后</span></span><span
        style="line-height: 150%;font-size: 16px">5</span><span style="line-height: 150%;font-size: 16px"><span>天内针对被申请人的反请求提交答辩。</span></span>
      </p>
      <p><span style="line-height: 150%;font-size: 16px">&nbsp;&nbsp;&nbsp;</span>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第三十五条</span> <span>裁决作出的期限</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>仲裁庭应当自组庭后</span>1</span><span
        style="line-height: 150%;font-size: 16px"><span>个月</span></span><span style="line-height: 150%;font-size: 16px"><span>内作出裁决</span></span><span
        style="line-height: 150%;font-size: 16px"><span>书</span></span><span
        style="line-height: 150%;font-size: 16px"><span>。</span></span><span
        style="line-height: 150%;font-size: 16px"><span>经</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁庭</span></span><span
        style="line-height: 150%;font-size: 16px"><span>请求</span></span><span style="line-height: 150%;font-size: 16px"><span>，仲裁委员会</span></span><span
        style="line-height: 150%;font-size: 16px"><span>仲裁院院长</span></span><span
        style="line-height: 150%;font-size: 16px"><span>认为确有</span></span><span
        style="line-height: 150%;font-size: 16px"><span>正当理由和</span></span><span
        style="line-height: 150%;font-size: 16px"><span>必要的，可以延长该期限。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span
          style="font-weight: 700;">第五章</span> </span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span style="font-weight: bold;">附则</span></span></strong>
      </p>
      <p style="line-height: 150%;background: rgb(255, 255, 255)">
        <span style="line-height:150%;color:rgb(102,102,102);font-size:16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>三十六</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>规则解释</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（一）本规则条文标题仅具有指引作用，不用于解释条文含义。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>（二）本规则由仲裁委员会负责解释。</span></span>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>第</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>三十七</span></span></strong><strong><span
        style="line-height: 150%;font-size: 16px"><span>条</span> <span>规则施行</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;&nbsp;&nbsp;</span><span
        style="line-height: 150%;font-size: 16px"><span>本规则自</span></span><span
        style="line-height: 150%;font-size: 16px">2020</span><span
        style="line-height: 150%;font-size: 16px"><span>年</span></span><span
        style="line-height: 150%;font-size: 16px">1</span><span
        style="line-height: 150%;font-size: 16px">&nbsp;<span>月</span>1日起施行。</span>
      </p>
      <p style=";line-height:150%">
        <strong><span style="line-height: 150%;font-size: 16px"><span>附件</span></span></strong>
      </p>
      <p style=";line-height:150%">
        <span style="line-height: 150%;font-size: 16px">&nbsp;</span>
      </p>
      <p style=";text-align:center;line-height:150%">
        <span style="line-height: 150%;font-size: 16px"><span>中国海事仲裁委员会网上仲裁</span></span><span
        style="line-height: 150%;font-size: 16px"><span>费用</span></span><span style="line-height: 150%;font-size: 16px"><span>表</span></span>
      </p>
      <table border="1" style="width: 100%; border-collapse: collapse;">
        <tbody>
        <tr style="height:43px" class="firstRow">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-width: 1px; border-color: windowtext; background: rgb(242, 220, 219);">
            <p style=";text-align:center">
              <span style="font-size: 16px">争议金额（人民币）</span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top-width: 1px; border-top-color: windowtext; border-bottom-width: 1px; border-bottom-color: windowtext; background: rgb(242, 220, 219);">
            <p style=";text-align:center">
              <span style="font-size: 16px">仲裁费用（人民币）</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">5,000<span>元以下</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">500</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">5,001<span>元至</span><span>10,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">1,000</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">10,001<span>元至</span><span>50,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">2,000</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">50,001<span>元至</span><span>100,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">4,000</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">100,001<span>元至</span><span>150,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">6,500</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">150,001<span>元至</span><span>200,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">9,500</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:33px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style=";text-align:right">
              <span style="font-size: 16px">200,001<span>元至</span><span>500,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">9,500</span><span style="font-size: 16px">元</span><span
              style="font-size: 16px">+<span>超过</span><span>20</span></span><span
              style="font-size: 16px">万元</span><span style="font-size: 16px">部分</span><span
              style="font-size: 16px">的</span><span style="font-size: 16px">3%</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">500,001<span>元至</span><span>1,000,000</span><span>元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">18,500</span><span style="font-size: 16px">元</span><span
              style="font-size: 16px">+<span>超过</span><span>50</span></span><span
              style="font-size: 16px">万元</span><span style="font-size: 16px">部分</span><span
              style="font-size: 16px">的</span><span style="font-size: 16px">1.7%</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">1,000,001<span>元至</span><span>2,000,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">27,000</span><span style="font-size: 16px">元</span><span
              style="font-size: 16px">+<span>超过</span><span>100</span></span><span
              style="font-size: 16px">万元</span><span style="font-size: 16px">部分</span><span
              style="font-size: 16px">的</span><span style="font-size: 16px">0.7%</span>
            </p>
          </td>
        </tr>
        <tr style="height:30px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: rgb(0, 0, 0);">
            <p style=";text-align:right">
              <span style="font-size: 16px">2,000,001<span>元至</span><span>10,000,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">34,000</span><span style="font-size: 16px">元</span><span
              style="font-size: 16px">+<span>超过</span><span>200</span></span><span
              style="font-size: 16px">万元</span><span style="font-size: 16px">部分</span><span
              style="font-size: 16px">的</span><span style="font-size: 16px">0.6%</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">10,000,001<span>元至</span><span>20,000,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">82,000</span><span style="font-size: 16px">元</span><span
              style="font-size: 16px">+<span>超过</span><span>1000</span></span><span
              style="font-size: 16px">万元</span><span style="font-size: 16px">部分</span><span
              style="font-size: 16px">的</span><span style="font-size: 16px">0.5%</span>
            </p>
          </td>
        </tr>
        <tr style="height:27px">
          <td width="213" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">20,000,001<span>元以上</span></span>
            </p>
          </td>
          <td width="344" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">132,000</span><span style="font-size: 16px">元</span><span
              style="font-size: 16px">+<span>超过</span><span>2000</span></span><span
              style="font-size: 16px">万元</span><span style="font-size: 16px">部分</span><span
              style="font-size: 16px">的</span><span style="font-size: 16px">0.4%</span>
            </p>
          </td>
        </tr>
        </tbody>
      </table>
      <p style="text-indent:32px;line-height:150%">
        <span style="line-height:150%;font-size:16px">&nbsp;</span>
      </p>
      <p style="line-height: 150%">
        <span style="line-height: 150%;font-size: 16px"><span>对于批量案件</span></span><span
        style="line-height: 150%;font-size: 16px"><span>，</span></span><span
        style="line-height: 150%;font-size: 16px"><span>按照下面收费办法</span>:</span>
      </p>
      <table border="1" style="width: 100%; border-collapse: collapse;">
        <tbody>
        <tr style="height:34px" class="firstRow">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-width: 1px; border-color: windowtext; background: rgb(228, 223, 236);">
            <p style=";text-align:center">
              <span style="font-size: 16px">争议金额（人民币）</span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top-width: 1px; border-top-color: windowtext; border-bottom-width: 1px; border-bottom-color: windowtext; background: rgb(228, 223, 236);">
            <p style=";text-align:center">
              <span style="font-size: 16px">仲裁费用（人民币）</span>
            </p>
          </td>
        </tr>
        <tr style="height:21px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">3,000<span>元以下</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">100</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">3,001<span>元至</span><span>5,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">200</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">5,001<span>元至</span><span>10,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">300</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">10,001<span>元至</span><span>50,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">800</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">50,001<span>元至</span><span>100,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">2</span><span style="font-size: 16px">,</span><span style="font-size: 16px">000</span><span
              style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">100,001<span>元至</span><span>150,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">3,000</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">150,001<span>元至</span><span>200,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">4,500</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">200,001<span>元至</span><span>300,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">5,500</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">300,001<span>元至</span><span>500,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">6,500</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">500,001<span>元至</span><span>1,000,000</span><span>元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">10,000</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">1,000,001<span>元至</span><span>2,000,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">15,000</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">2,000,001<span>元至</span><span>5,000,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">32,000</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        <tr style="height:17px">
          <td width="217" valign="center"
              style="padding: 0px 7px; border-left-width: 1px; border-left-color: windowtext; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:right">
              <span style="font-size: 16px">5,000,001<span>元至</span><span>10,000,000</span><span
              >元</span></span>
            </p>
          </td>
          <td width="340" valign="center"
              style="padding: 0px 7px; border-left: none; border-right-width: 1px; border-right-color: windowtext; border-top: none; border-bottom-width: 1px; border-bottom-color: windowtext;">
            <p style=";text-align:center">
              <span style="font-size: 16px">52,000</span><span style="font-size: 16px">元</span>
            </p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>
        <br/>
      </p>
    </div>
    <div v-else class="xianxia">
      <h4 style="line-height:175%;text-align: center;font-size: 19px;font-weight: normal;">
        <span style="font-size: 19px;">中国海事仲裁委员会仲裁规则</span>
      </h4>
      <p style="; text-align: center;">
        <span style="font-size: 16px;line-height: 175%;font-weight: 700;">第一章</span>
        <span style="font-size: 16px;line-height: 175%;font-weight: bold;">总则</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第一条 仲裁委员会</span>
      </p>
      <p style=";text-indent:2em;">
        <span style=" font-size: 16px;">（一）中国海事仲裁委员会（以下简称“仲裁委员会”），原名中国国际贸易促进委员会海事仲裁委员会。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（二）当事人在仲裁协议中订明由中国国际贸易促进</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">委员会</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;">中国国际商会的海事仲裁委员会仲裁的，或使用仲裁委员会原名称为仲裁机构的，均视为同意由中国海事仲裁委员会仲裁。</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二条 机构及职责</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁委员会秘书长履行本规则赋予的职责。副秘书长根据秘书长的授权可以履行秘书长的职责。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁委员会设有仲裁院，在授权的副秘书长和仲裁院院长的领导下履行本规则规定的职责。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;"><span style="font-size: 16px;">（三）仲裁委员会设在北京。仲裁委员会设有分会</span> / 仲裁中心（本规则附件一）。仲裁委员会的分会 / 仲裁中心是仲裁委员会的派出机构，根据仲裁委员会的授权，接受仲<span
          style="font-size: 16px;">裁申请，管理仲裁案件。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（四）</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">分会</span> </span><span style=" font-size: 16px;">/</span><span
          style=" letter-spacing: -5px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">仲裁中心设仲裁院，在分会</span> </span><span style=" font-size: 16px;">/</span><span
          style=" letter-spacing: -5px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;">仲裁中心</span><span
          style=" font-size: 16px;">仲裁院院长的领导下履行本规则规定由仲裁委员会仲裁院履行的职责。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（五）</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">案件由分会</span> </span><span style=" font-size: 16px;">/</span><span
          style=" font-size: 16px;">&nbsp;<span
          style="font-size: 16px;">仲裁中心管理的，本规则规定由仲裁委员会仲裁院院长履行的职责，由仲裁委员会仲裁院院长授权的分会</span> </span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">仲裁中心仲裁院院长履行。</span></span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（六）双方当事人约定将其争议提交仲裁委员会仲裁</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">的，根据申请人的选择，由仲裁委员会仲裁院或仲裁委员会分会</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">仲裁中心仲裁院接受仲裁申请并管理案件。双方当事人都提出仲裁申请的，以首先申请的为准。双方当事人约定将其争议提交仲裁委员会在北京或约定将其争议提交仲裁委员会分会</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">仲裁中心或在其所在地仲裁的，分别由仲裁委员会仲裁院或仲裁委员会分会</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">仲裁中心仲裁院接受仲裁申请并管理案件。约定的分会</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">仲裁中心不存在或约定不明的，</span> <span
          style="font-size: 16px;">由仲裁委员会仲裁院接受仲裁申请并管理案件。如有争议，</span> <span
          style="font-size: 16px;">由仲裁委员会作出决定。</span></span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三条 受案范围</span>
      </p>
      <p>
        <span style=" font-size: 16px;">（一）仲裁委员会根据当事人的约定受理下列争议案件：</span>
      </p>
      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">1.&nbsp;</span><span style=" font-size: 16px;">海事、海商争议案件；</span></span>
      </p>
      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">2.&nbsp;</span><span style=" font-size: 16px;">航空、铁路、公路等相关争议案件；</span></span>
      </p>
      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">3.&nbsp;</span><span style=" font-size: 16px;">贸易、投资、金融、保险、建筑等其他商事争议案件；</span></span>
      </p>
      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">4.&nbsp;</span><span style=" font-size: 16px;">当事人协议由仲裁委员会仲裁的其他争议案件。</span></span>
      </p>
      <p>
        <span style=" font-size: 16px;">（二）前述案件包括：</span>
      </p>
      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">1.&nbsp;</span><span style=" font-size: 16px;">国际或涉外争议案件；</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style="font-size: 16px;">2.&nbsp;</span><span style=" font-size: 16px;">涉及香港特别行政区、澳门特别行政区及台湾地区</span><span
          style=" font-size: 16px;">的争议案件；</span></span>
      </p>
      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">3.&nbsp;</span><span style=" font-size: 16px;">国内争议案件。</span></span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四条 规则的适用</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;"><span style="font-size: 16px;">（一）本规则统一适用于仲裁委员会及其分会</span> / 仲裁<span
          style="font-size: 16px;">中心。</span></span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）当事人约定将争议提交仲裁委员会仲裁的，视为同意按照本规则进行仲裁。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）当事人约定将争议提交仲裁委员会仲裁但对本规则有关内容进行变更或约定适用其他仲裁规则的，从其约定，但其约定无法实施或与仲裁程序适用法强制性规定相抵触者除外。当事人约定适用其他仲裁规则的，由仲裁委员会履行相应的管理职责。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）当事人约定按照本规则进行仲裁但未约定仲裁机构的，视为同意将争议提交仲裁委员会仲裁。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（五）当事人约定适用仲裁委员会专业仲裁规则的， 从其约定，但其争议不属于该专业仲裁规则适用范围的，适用本规则。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五条 仲裁协议</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁协议指当事人在合同中订明的仲裁条款或以其他方式达成的提交仲裁的书面协议。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁协议应当采取书面形式。书面形式包括合同书、信件、电报、电传、传真、电子数据交换和电子邮件等可以有形地表现所载内容的形式。在仲裁申请书和仲裁答辩书的交换中，一方当事人声称有仲裁协议而另一方当事人不做否认表示的，视为存在书面仲裁协议。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）仲裁协议的适用法对仲裁协议的形式及效力另有规定的，从其规定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）合同中的仲裁条款应视为与合同其他条款分离的、独立存在的条款，附属于合同的仲裁协议也应视为与合同其他条款分离的、独立存在的一个部分；合同的变更、解除、终止、转让、失效、无效、未生效、被撤销以及成立与否，均不影响仲裁条款或仲裁协议的效力。</span>
      </p>
      <p>
        <span style="line-height: 142%;  font-size: 16px;"><br/></span>
      </p>
      <p style="font-weight: bold;">
        <span style="font-size: 16px;"><span style=" font-size: 13px;"><span style="font-size: 16px;">第六条</span> 对仲裁协议及/或管辖权的异议</span></span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁委员会有权对仲裁协议的存在、效力以及仲裁案件的管辖权作出决定。如有必要，仲裁委员会也可以授权仲裁庭作出管辖权决定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（二）仲裁委员会依表面证据认为存在有效仲裁协议</span><span
          style=" font-size: 16px;">的，可根据表面证据作出仲裁委员会有管辖权的决定，仲裁程序继续进行。仲裁委员会依表面证据作出的管辖权决定并不妨碍其根据仲裁庭在审理过程中发现的与表面证据不一致</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">的事实及</span> </span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">或证据重新作出管辖权决定。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）仲裁庭依据仲裁委员会的授权作出管辖权决定时，可以在仲裁程序进行中单独作出，也可以在裁决书中一并作出。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">四</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">）当事人对仲裁协议及</span> </span><span style=" font-size: 16px;">/</span><span
          style=" letter-spacing: -3px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;">或仲裁案件管辖权的异</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">议，应当在仲裁庭首次开庭前书面提出；书面审理的案件，</span> <span
          style="font-size: 16px;">应当在第一次实体答辩前提出。</span></span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;"><span style="font-size: 16px;">（五）对仲裁协议及</span> / 或仲裁案件管辖权提出异议不<span
          style="font-size: 16px;">影响仲裁程序的继续进行。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（六）</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">上述管辖权异议及</span> </span><span style=" font-size: 16px;">/</span><span
          style=" font-size: 16px;">&nbsp;<span style="font-size: 16px;">或决定包括仲裁案件主体资格异议及</span> </span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">或决定。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（七）仲裁委员会或经仲裁委员会授权的仲裁庭作出</span><span
          style=" font-size: 16px;">无管辖权决定的，应当作出撤销案件的决定。撤案决定在仲</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">裁庭组成前由仲裁委员会仲裁院院长作出，在仲裁庭组成后，</span> </span><span
          style=" font-size: 16px;">由仲裁庭作出。</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七条 仲裁地</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（一）当事人对仲裁地有约定的，从其约定。</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（二）当事人对仲裁地未作约定或约定不明的，以管</span>
      </p>

      <p>
        <span style=" font-size: 16px;">理案件的仲裁委员会或其分会 / 仲裁中心所在地为仲裁地； 仲裁委员会也可视案件的具体情形确定其他地点为仲裁地。</span>
      </p>
      <p>
        <span style=" font-size: 16px;">（三）仲裁裁决视为在仲裁地作出。</span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第八条 送达及期限</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）有关仲裁的一切文书、通知、材料等均可采用当面递交、挂号信、特快专递、传真或仲裁委员会仲裁院或仲裁庭认为适当的其他方式发送。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）上述第（一）款所述仲裁文件应发送当事人或其仲裁代理人自行提供的或当事人约定的地址；当事人或其仲裁代理人没有提供地址或当事人对地址没有约定的，按照对方当事人或其仲裁代理人提供的地址发送。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（三</span><span style=" font-size: 16px;">）</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">向一方当事人或其仲裁代理人发送的仲裁文件，</span> <span
          style="font-size: 16px;">如经当面递交收件人或发送至收件人的营业地、注册地、住所地、惯常居住地或通讯地址，或经对方当事人合理查询不能找到上述任一地点，仲裁委员会仲裁院以挂号信或特快专递或能提供投递记录的包括公证送达、委托送达和留置送达在内的其他任何手段投递给收件人最后一个为人所知的营业地、注册地、住所地、惯常居住地或通讯地址，即视为有效</span></span><span
          style=" font-size: 16px;">送达。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）本规则所规定的期限，应自当事人收到或应当收到仲裁委员会仲裁院向其发送的文书、通知、材料等之日的次日起计算。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第九条 诚实信用</span>
      </p>

      <p>
        <span style=" font-size: 16px;">仲裁参与人应遵循诚实信用原则，进行仲裁程序。</span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十条 放弃异议</span>
      </p>

      <p>
        <span style=" font-size: 16px;">一方当事人知道或理应知道本规则或仲裁协议中规定的任何条款或情事未被遵守，仍参加仲裁程序或继续进行仲裁程序而且不对此不遵守情况及时地、明示地提出书面异议的，视为放弃其提出异议的权利。</span>
      </p>


      <p style="text-align:center">
        <span style="font-size: 16px;"><span style=" font-size: 16px;font-weight: 700;">第二章</span> <span
          style="font-weight: 700; font-size: 16px;">仲裁程序</span></span>
      </p>

      <p style="text-align:center">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">第一节</span> <span style=" font-size: 16px;">仲裁申请、答辩、反请求</span></span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十一条 仲裁程序的开始</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">仲裁程序自仲裁委员会仲裁院收到仲裁申请书之日起开始。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十二条 申请仲裁</span>
      </p>

      <p>
        <span style=" font-size: 16px;">当事人依据本规则申请仲裁时应：</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;"><span style="font-size: 16px;">（一）提交由申请人或申请人授权的代理人签名及</span> / <span
          style="font-size: 16px;">或盖章的仲裁申请书。仲裁申请书应写明：</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style="font-size: 16px;">1.&nbsp;</span><span style=" font-size: 16px;">申请人和被申请人的名称和住所，包括邮政编码、电话、传真、电子邮箱或其他电子通讯方式；</span></span>
      </p>
      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">2.&nbsp;</span><span style=" font-size: 16px;">申请仲裁所依据的仲裁协议；</span></span>
      </p>

      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">3.&nbsp;</span><span style=" font-size: 16px;">案情和争议要点；</span></span>
      </p>

      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">4.&nbsp;</span><span style=" font-size: 16px;">申请人的仲裁请求；</span></span>
      </p>

      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">5.&nbsp;</span><span style=" font-size: 16px;">仲裁请求所依据的事实和理由。</span></span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）在提交仲裁申请书时，附具申请人请求所依据的证据材料以及其他证明文件。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）按照仲裁委员会制定的仲裁费用表的规定预缴仲裁费。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十三条 案件的受理</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁委员会根据当事人在争议发生之前或在争议发生之后达成的将争议提交仲裁委员会仲裁的仲裁协议和</span>
      </p>

      <p>
        <span style=" font-size: 16px;">一方当事人的书面申请，受理案件。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁委员会仲裁院收到申请人的仲裁申请书及其附件后，经审查，认为申请仲裁的手续完备的，应将仲裁通知、仲裁委员会仲裁规则和仲裁员名册各一份发送给双方当事人；申请人的仲裁申请书及其附件也应同时发送给被申请人。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）仲裁委员会仲裁院经审查认为申请仲裁的手续不完备的，可以要求申请人在一定的期限内予以完备。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）仲裁委员会受理案件后，仲裁委员会仲裁院应指定一名案件秘书协助仲裁案件的程序管理。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十四条 多份合同的仲裁</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">申请人就多份合同项下的争议可在同一仲裁案件中合并提出仲裁申请，但应同时符合下列条件：</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style="font-size: 16px;">1.&nbsp;</span><span style=" font-size: 16px;">多份合同系主从合同关系；或多份合同所涉当事人</span><span
          style=" font-size: 16px;">相同且法律关系性质相同；</span></span>
      </p>
      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">2.&nbsp;</span><span style=" font-size: 16px;">争议源于同一交易或同一系列交易；</span></span>
      </p>

      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">3.&nbsp;</span><span style=" font-size: 16px;">多份合同中的仲裁协议内容相同或相容。</span></span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十五条 答辩</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）被申请人应自收到仲裁通知后 30 天内提交答辩书。被申请人确有正当理由请求延长提交答辩期限的，由仲裁庭决定是否延长答辩期限；仲裁庭尚未组成的，由仲裁委员会仲裁院作出决定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;"><span style="font-size: 16px;">（二）答辩书由被申请人或被申请人授权的代理人签名及</span> </span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">或盖章，并应包括下列内容及附件：</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style="font-size: 16px;">1.&nbsp;</span><span style=" font-size: 16px;">被申请人的名称和住所，包括邮政编码、电话、传真、</span><span
          style=" font-size: 16px;">电子邮箱或其他电子通讯方式；</span></span>
      </p>

      <p style="margin-top: 4px;">
        <span style="font-size: 16px;"><span style="font-size: 16px;">2.&nbsp;</span><span style=" font-size: 16px;">对仲裁申请书的答辩及所依据的事实和理由；</span></span>
      </p>

      <p>
        <span style="font-size: 16px;"><span style="font-size: 16px;">3.&nbsp;</span><span style=" font-size: 16px;">答辩所依据的证据材料以及其他证明文件。</span></span>
      </p>

      <p>
        <span style=" font-size: 16px;">（三）仲裁庭有权决定是否接受逾期提交的答辩书。</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（四）被申请人未提交答辩书，不影响仲裁程序的进行。</span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十六条 反请求</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）被申请人如有反请求，应自收到仲裁通知后 30 天内以书面形式提交。被申请人确有正当理由请求延长提交反请求期限的，由仲裁庭决定是否延长反请求期限；仲裁庭尚未组成的，由仲裁委员会仲裁院作出决定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）被申请人提出反请求时，应在其反请求申请书中写明具体的反请求事项及其所依据的事实和理由，并附具有关的证据材料以及其他证明文件。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）被申请人提出反请求，应按照仲裁委员会制定的仲裁费用表在规定的时间内预缴仲裁费。被申请人未按期缴纳反请求仲裁费的，视同未提出反请求申请。</span>
      </p>
      <p style=";text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（四）仲裁委员会仲裁院认为被申请人提出反请求的</span><span
          style=" font-size: 16px;">手续已完备的，应向双方当事人发出反请求受理通知。申请</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">人应在收到反请求受理通知后</span> </span><span style=" font-size: 16px;">30 </span><span
          style=" font-size: 16px;">天内针对被申请人的反请</span><span style=" font-size: 16px;"><span style="font-size: 16px;">求提交答辩。申请人确有正当理由请求延长提交答辩期限的，</span> </span><span
          style=" font-size: 16px;">由仲裁庭决定是否延长答辩期限；仲裁庭尚未组成的，由仲裁委员会仲裁院作出决定。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（五）仲裁庭有权决定是否接受逾期提交的反请求和反请求答辩书。</span>
      </p>
      <p style=";text-indent:2em;">
        <span style=" font-size: 16px;">（六）申请人对被申请人的反请求未提出书面答辩的， 不影响仲裁程序的进行。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十七条 变更仲裁请求或反请求</span>
      </p>

      <p style="text-indent:2em;">
        <span
          style=" font-size: 16px;">申请人可以申请对其仲裁请求进行变更，被申请人也可以申请对其反请求进行变更；但是仲裁庭认为其提出变更的时间过迟而影响仲裁程序正常进行的，可以拒绝其变更请求。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十八条 追加当事人</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）在仲裁程序中，一方当事人依据表面上约束被追加当事人的案涉仲裁协议可以向仲裁委员会申请追加当事人。在仲裁庭组成后申请追加当事人的，如果仲裁庭认为确有必要，应在征求包括被追加当事人在内的各方当事人的意见后，由仲裁委员会作出决定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">仲裁委员会仲裁院收到追加当事人申请之日视为针对该被追加当事人的仲裁开始之日。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（二</span><span style=" font-size: 16px;">）</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">追加当事人申请书应包含现有仲裁案件的案号，</span> <span
          style="font-size: 16px;">涉及被追加当事人在内的所有当事人的名称、住所及通讯方式，追加当事人所依据的仲裁协议、事实和理由，以及仲裁</span></span><span
          style=" font-size: 16px;">请求。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">当事人在提交追加当事人申请书时，应附具其申请所依据的证据材料以及其他证明文件。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（三）任何一方当事人就追加当事人程序提出仲裁协</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">议及</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;">或仲裁案件管辖权异议的，仲裁委员会有权基于仲裁协议及相关证据作出是否具有管辖权的决定。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）追加当事人程序开始后，在仲裁庭组成之前， 由仲裁委员会仲裁院就仲裁程序的进行作出决定；在仲裁庭组成之后，由仲裁庭就仲裁程序的进行作出决定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（五）在仲裁庭组成之前追加当事人的，本规则有关当事人选定或委托仲裁委员会秘书长指定仲裁员的规定适用于被追加当事人。仲裁庭的组成应按照本规则第三十三条的规定进行。</span>
      </p>

      <p style=";text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">在仲裁庭组成后决定追加当事人的，仲裁庭应就已经</span><span
          style=" font-size: 16px;">进行的包括仲裁庭组成在内的仲裁程序征求被追加当事人的意见。被追加当事人要求选定或委托仲裁委员会秘书长指定仲裁员的，双方当事人应重新选定或委托仲裁委员会秘书长指定</span><span
          style=" font-size: 16px;">仲裁员。仲裁庭的组成应按照本规则第三十三条的规定进行。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（六）本规则有关当事人提交答辩及反请求的规定适用于被追加当事人。被追加当事人提交答辩及反请求的期限自收到追加当事人仲裁通知后起算。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（七）案涉仲裁协议表面上不能约束被追加当事人或存在其他任何不宜追加当事人的情形的，仲裁委员会有权决定不予追加。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第十九条 合并仲裁</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）符合下列条件之一的，经一方当事人请求，仲裁委员会可以决定将根据本规则进行的两个或两个以上的仲裁案件合并为一个仲裁案件，进行审理。</span>
      </p>
      <p style="text-align:justify;text-justify:inter-ideograph">
        <span style="font-size: 16px;"><span style="font-size: 16px;">1.&nbsp;</span><span style=" font-size: 16px;">各案仲裁请求依据同一个仲裁协议提出；</span></span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style="font-size: 16px;">2.&nbsp;</span><span style=" font-size: 16px;">各案仲裁请求依据多份仲裁协议提出，该多份仲裁</span><span
          style=" font-size: 16px;">协议内容相同或相容，且各案当事人相同、各争议所涉及的法律关系性质相同；</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style="font-size: 16px;">3.&nbsp;</span><span style=" font-size: 16px;">各案仲裁请求依据多份仲裁协议提出，该多份仲裁</span><span
          style=" font-size: 16px;">协议内容相同或相容，且涉及的多份合同为主从合同关系；</span></span>
      </p>
      <p style="text-align:justify;text-justify:inter-ideograph">
        <span style="font-size: 16px;"><span style="font-size: 16px;">4.&nbsp;</span><span style=" font-size: 16px;">所有案件的当事人均同意合并仲裁。</span></span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）根据上述第（一）款决定合并仲裁时，仲裁委员会应考虑各方当事人的意见及相关仲裁案件之间的关联性等因素，包括不同案件的仲裁员的选定或指定情况。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）除非各方当事人另有约定，合并的仲裁案件应合并至最先开始仲裁程序的仲裁案件。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）仲裁案件合并后，在仲裁庭组成之前，由仲裁委员会仲裁院就程序的进行作出决定；仲裁庭组成后，由仲裁庭就程序的进行作出决定。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十条 仲裁文件的提交与交换</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（一）当事人的仲裁文件应提交至仲裁委员会仲裁院。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁程序中需发送或转交的仲裁文件，由仲裁委员会仲裁院发送或转交仲裁庭及当事人，当事人另有约定并经仲裁庭同意或仲裁庭另有决定者除外。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十一条 仲裁文件的份数</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">当事人提交的仲裁申请书、答辩书、反请求书和证据材料以及其他仲裁文件，应一式五份；多方当事人的案件， 应增加相应份数；当事人提出财产保全申请或证据保全申请的，应增加相应份数；仲裁庭组成人数为一人的，应相应减少两份。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十二条 仲裁代理人</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;"><span style="font-size: 16px;">当事人可以授权中国及</span> </span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -3px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">或外国的仲裁代理人办理有关仲裁事项。当事人或其仲裁代理人应向仲裁委员会仲裁院</span><span style=" font-size: 16px;">提交授权委托书。</span></span>
      </p>
      <p style="text-align:center">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">第二节</span> <span style=" font-size: 16px;">保全及临时措施</span></span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十三条 财产保全</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">当事人申请海事请求保全或其他财产保全的，仲裁委员会应当将当事人的申请提交被申请人住所地或其财产所在地的海事法院或其他有管辖权的法院做出裁定；当事人在仲裁程序开始前申请海事请求保全或其他财产保全的，应当依照《中华人民共和国海事诉讼特别程序法》的规定或其他有关规定，直接向被保全的财产所在地海事法院或其他有管辖权的法院提出。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十四条 证据保全</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">当事人申请证据保全的, 仲裁委员会应当将当事人的申请提交证据所在地的海事法院或其他有管辖权的法院做出裁定；当事人在仲裁程序开始前申请证据保全的，应当依照《中华人民共和国海事诉讼特别程序法》的规定或其他有关法律规定，直接向被保全的证据所在地海事法院或其他有管辖权的法院提出。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十五条 海事强制令</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">当事人申请海事强制令的，仲裁委员会应当将当事人的申请提交海事纠纷发生地的海事法院做出裁定；当事人在仲裁程序开始前申请海事强制令的，应当依照《中华人民共和国海事诉讼特别程序法》的规定，直接向海事纠纷发生地的海事法院提出。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十六条 海事赔偿责任限制基金</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">当事人申请设立海事赔偿责任限制基金的，仲裁委员会应当将当事人的申请提交事故发生地、合同履行地或者船舶扣押地海事法院作出裁定；当事人在仲裁程序开始前申请设立海事赔偿责任限制基金的，应当依照《中华人民共和国海事诉讼特别程序法》的规定，直接向事故发生地、合同履行地或者船舶扣押地的海事法院提出。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十七条 临时措施</span>
      </p>

      <p style="text-indent:2em;">
        <span
          style=" font-size: 16px;">（一）根据所适用的法律或当事人的约定，当事人可以依据《中国海事仲裁委员会紧急仲裁员程序》（本规则附件三）向仲裁委员会仲裁院申请紧急性临时救济。紧急仲裁员可以决定采取必要或适当的紧急性临时救济措施。紧急仲裁员的决定对双方当事人具有约束力。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（二）经一方当事人请求，仲裁庭依据所适用的法律或当事人的约定可以决定采取其认为必要或适当的临时措施，</span><span
          style=" font-size: 16px;">并有权决定由请求临时措施的一方当事人提供适当的担保。</span></span>
      </p>

      <p style="text-align:center">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">第三节</span> <span style=" font-size: 16px;">仲裁员及仲裁庭</span></span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十八条 仲裁员的义务</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">仲裁员不代表任何一方当事人，应独立于各方当事人， 平等地对待各方当事人。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第二十九条 仲裁庭的人数</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（一）仲裁庭由一名或三名仲裁员组成。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）除非当事人另有约定或本规则另有规定，仲裁庭由三名仲裁员组成。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十条 仲裁员的选定或指定</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;"><span style="font-size: 16px;">（一）仲裁委员会制定统一适用于仲裁委员会及其分会</span> </span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">仲裁中心的仲裁员名册；当事人从仲裁委员会制定的仲裁员名册中选定仲裁员。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）当事人约定在仲裁委员会仲裁员名册之外选定仲裁员的，当事人选定的或根据当事人约定指定的人士经仲裁委员会秘书长确认后可以担任仲裁员。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十一条 三人仲裁庭的组成</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）申请人和被申请人应各自在收到仲裁通知后 15 天内选定或委托仲裁委员会秘书长指定一名仲裁员。当事人未在上述期限内选定或委托仲裁委员会秘书长指定的，由仲裁委员会秘书长指定。</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（二）第三名仲裁员由双方当事人在被申请人收到仲裁通知后</span><span
          style=" font-size: 16px;">15</span><span style=" letter-spacing: -2px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">天内共同选定或共同委托仲裁委员会秘书长指定。第三名仲裁员为仲裁庭的首席仲裁员。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）双方当事人可以各自推荐一至五名候选人作为首席仲裁员人选，并按照上述第（二）款规定的期限提交推荐名单。双方当事人的推荐名单中有一名人选相同的，该人选为双方当事人共同选定的首席仲裁员；有一名以上人选相同的，由仲裁委员会秘书长根据案件的具体情况在相同人选中确定一名首席仲裁员，该名首席仲裁员仍为双方共同选定的首席仲裁员；推荐名单中没有相同人选时，由仲裁委员会秘书长指定首席仲裁员。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）双方当事人未能按照上述规定共同选定首席仲裁员的，由仲裁委员会秘书长指定首席仲裁员。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十二条 独任仲裁庭的组成</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">仲裁庭由一名仲裁员组成的，按照本规则第三十一条第（二）、（三）、（四）款规定的程序，选定或指定独任仲裁员。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十三条 多方当事人仲裁庭的组成</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;"><span style="font-size: 16px;">（一）仲裁案件有两个或两个以上申请人及</span> / 或被申请人时，申请人方及 / 或被申请人方应各自协商，各方共同<span
          style="font-size: 16px;">选定或共同委托仲裁委员会秘书长指定一名仲裁员。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（二</span><span style=" font-size: 16px;">）</span><span
          style=" font-size: 16px;">首席仲裁员或独任仲裁员应按照本规则第三十一</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">条第（二）、（三）、（四）款规定的程序选定或指定。申请人方及</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;">或被申请人方按照本规则第三十一条第（三）</span><span
          style=" font-size: 16px;">款</span><span style=" font-size: 16px;"><span style="font-size: 16px;">的规定选定首席仲裁员或独任仲裁员时，应各方共同协商，</span> </span><span
          style=" font-size: 16px;">提交各方共同选定的候选人名单。</span></span>
      </p>
      <p style="text-align:justify;text-justify:inter-ideograph">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（三）</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">如果申请人方及</span> /</span><span
          style=" letter-spacing: -6px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">或被申请人方未能在收到仲</span>裁通知后 15 天内各方共同选定或各方共同委托仲裁委员会秘书长指定一名仲裁员，则由仲裁委员会秘书长指定仲裁庭三名仲裁员，并从中确定一人担任首席仲裁员。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十四条 指定仲裁员的考虑因素</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">仲裁委员会秘书长根据本规则的规定指定仲裁员时，应考虑争议的适用法律、仲裁地、仲裁语言、当事人国籍，以及仲裁委员会秘书长认为应考虑的其他因素。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十五条 披露</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）被选定或被指定的仲裁员应签署声明书，披露可能引起对其公正性和独立性产生合理怀疑的任何事实或情况。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）在仲裁程序中出现应披露情形的，仲裁员应立即书面披露。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;"><span style="font-size: 16px;">（三）仲裁员的声明书及</span> / 或披露的信息应提交仲裁<span
          style="font-size: 16px;">委员会仲裁院并转交各方当事人。</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十六条 仲裁员的回避</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（一</span><span
          style=" letter-spacing: -2px; font-size: 16px;">）</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">当事人收到仲裁员的声明书及</span> </span><span style=" font-size: 16px;">/</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">或书面披露后，</span> </span><span style=" font-size: 16px;"><span style="font-size: 16px;">如果以披露的事实或情况为理由要求该仲裁员回避，则应于收到仲裁员的书面披露后</span> </span><span
          style=" font-size: 16px;">10 </span><span
          style=" font-size: 16px;">天内书面提出。逾期没有申请回避的，不得以仲裁员曾经披露的事项为由申请该仲裁员回</span><span
          style=" font-size: 16px;">避。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）当事人对被选定或被指定的仲裁员的公正性和独立性产生具有正当理由的怀疑时，可以书面提出要求该仲裁员回避的请求，但应说明提出回避请求所依据的具体事实和理由，并举证。</span>
      </p>
      <p>
        <span style=" font-size: 16px;">（三）对仲裁员的回避请求应在收到组庭通知后 15 天内以书面形式提出；在此之后得知要求回避事由的，可以在得知回避事由后 15 天内提出，但应不晚于最后一次开庭终结。</span>
      </p>
      <p style=";text-indent:2em;">
        <span style=" font-size: 16px;">（四）当事人的回避请求应当立即转交另一方当事人、被请求回避的仲裁员及仲裁庭其他成员。</span>
      </p>
      <p style=";text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">五</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">如果一方当事人请求仲裁员回避，另一方当事</span><span
          style=" font-size: 16px;">人同意回避请求，或被请求回避的仲裁员主动提出不再担任</span><span style=" font-size: 16px;">该仲裁案件的仲裁员，则该仲裁员不再担任仲裁员审理本案。</span><span
          style=" font-size: 16px;">上述情形并不表示当事人提出回避的理由成立。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（六）除上述第（五）款规定的情形外，仲裁员是否回避，由仲裁委员会秘书长作出终局决定并可以不说明理由。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（七）在仲裁委员会秘书长就仲裁员是否回避作出决定前，被请求回避的仲裁员应继续履行职责。</span>
      </p>
      <p style="font-weight: bold;text-align:justify;text-justify:inter-ideograph">
        <span style=" font-size: 16px;">第三十七条 仲裁员的更换</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">一</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">仲裁员在法律上或事实上不能履行职责，或没</span><span
          style=" font-size: 16px;">有按照本规则的要求或在本规则规定的期限内履行应尽职责时，仲裁委员会秘书长有权决定将其更换；该仲裁员也可以主动申请不再担任仲裁员。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">二</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">是否更换仲裁员，由仲裁委员会秘书长作出终局</span><span
          style=" font-size: 16px;">决定并可以不说明理由。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）在仲裁员因回避或更换不能履行职责时，应按照原选定或指定仲裁员的方式在仲裁委员会仲裁院规定的期限内选定或指定替代的仲裁员。当事人未选定或指定替代仲裁员的，由仲裁委员会秘书长指定替代的仲裁员。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）重新选定或指定仲裁员后，由仲裁庭决定是否重新审理及重新审理的范围。</span>
      </p>
      <p>
        <span style="line-height: 142%;  font-size: 16px;"><br/></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十八条 多数仲裁员继续仲裁程序</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">最后一次开庭终结后，如果三人仲裁庭中的一名仲裁</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">员因死亡或被除名等情形而不能参加合议及</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">或作出裁决，</span> <span style="font-size: 16px;">另外两名仲裁员可以请求仲裁委员会秘书长按照第三十七条的规定更换该仲裁员；在征求双方当事人意见并经仲裁委员会秘书长同意后，该两名仲裁员也可以继续进行仲裁程序，作出决定或裁决。仲裁委员会仲裁院应将上述情况通知双方当事人。</span></span></span>
      </p>
      <p style="text-align:center">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">第四节</span> <span
          style=" font-size: 16px;">审理</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第三十九条 审理方式</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）除非当事人另有约定，仲裁庭可以按照其认为适当的方式审理案件。在任何情形下，仲裁庭均应公平和公正地行事，给予双方当事人陈述与辩论的合理机会。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁庭应开庭审理案件，但双方当事人约定并经仲裁庭同意或仲裁庭认为不必开庭审理并征得双方当事人同意的，可以只依据书面文件进行审理。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）除非当事人另有约定，仲裁庭可以根据案件的具体情况采用询问式或辩论式的庭审方式审理案件。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（四）仲裁庭可以在其认为适当的地点以其认为适当</span><span
          style=" font-size: 16px;">的方式进行合议。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;">（五）除非当事人另有约定，仲裁庭认为必要时可以就所审理的案件发布程序令、发出问题单、制作审理范围书、举行庭前会议等。经仲裁庭其他成员授权，首席仲裁员可以单独就仲裁案件的程序安排作出决定。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十条 开庭地</span>
      </p>
      <p style=";text-indent:2em;">
        <span style=" font-size: 16px;">（一）当事人约定了开庭地点的，仲裁案件的开庭审理应当在约定的地点进行，但出现本规则第七十九条第（三） 款规定的情形的除外。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">二</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">除非当事人另有约定，由仲裁委员会仲裁院或</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">其分会</span> </span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -3px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">仲裁中心仲裁院管理的案件应分别在北京或分会</span> </span><span
          style=" font-size: 16px;">/ <span
          style="font-size: 16px;">仲裁中心所在地开庭审理；如仲裁庭认为必要，经仲裁委员会仲裁院院长同意，也可以在其他地点开庭审理。</span></span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十一条 开庭通知</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）开庭审理的案件，仲裁庭确定第一次开庭日期后，应不晚于开庭前 20 天将开庭日期通知双方当事人。当事人有正当理由的，可以请求延期开庭，但应于收到开庭通知后 5 天内提出书面延期申请；是否延期，由仲裁庭决定。</span>
      </p>
      <p style=";text-indent:2em;">
        <span style=" font-size: 16px;">（二）当事人有正当理由未能按上述第（一）款规定提出延期开庭申请的，是否接受其延期申请，由仲裁庭决定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）再次开庭审理的日期及延期后开庭审理日期的通知及其延期申请，不受上述第（一）款期限的限制。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十二条 保密</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁庭审理案件不公开进行。双方当事人要求公开审理的，由仲裁庭决定是否公开审理。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）不公开审理的案件，双方当事人及其仲裁代理人、仲裁员、证人、翻译、仲裁庭咨询的专家和指定的鉴定人，以及其他有关人员，均不得对外界透露案件实体和程序的有关情况。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十三条 当事人缺席</span>
      </p>

      <p style=";text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">一</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">申请人无正当理由开庭时不到庭的，或在开庭</span><span
          style=" font-size: 16px;">审理时未经仲裁庭许可中途退庭的，可以视为撤回仲裁申请；</span></span>
      </p>

      <p>
        <span style=" font-size: 16px;">被申请人提出反请求的，不影响仲裁庭就反请求进行审理， 并作出裁决。</span>
      </p>
      <p style="text-indent:2em;">
        <span
          style=" font-size: 16px;">（二）被申请人无正当理由开庭时不到庭的，或在开庭审理时未经仲裁庭许可中途退庭的，仲裁庭可以进行缺席审理并作出裁决；被申请人提出反请求的，可以视为撤回反请求。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十四条 庭审笔录</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;"><span style="font-size: 16px;">（一）开庭审理时，仲裁庭可以制作庭审笔录及</span> </span><span
          style=" font-size: 16px;">/</span><span style=" font-size: 16px;">&nbsp;<span style="font-size: 16px;">或影音记录。仲裁庭认为必要时，可以制作庭审要点，并要求</span></span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">当事人及</span> </span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">或其代理人、证人及</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;">或其他有关人员在庭审</span><span
          style=" font-size: 16px;">笔录或庭审要点上签字或盖章。</span></span>
      </p>
      <p>
        <span style=" font-size: 16px;">（二）庭审笔录、庭审要点和影音记录供仲裁庭查用。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）应一方当事人申请，仲裁委员会仲裁院视案件具体情况可以决定聘请速录人员速录庭审笔录，当事人应当预交由此产生的费用。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十五条 举证</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）当事人应对其申请、答辩和反请求所依据的事实提供证据加以证明，对其主张、辩论及抗辩要点提供依据。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁庭可以规定当事人提交证据的期限。当事人应在规定的期限内提交证据。逾期提交的，仲裁庭可以不予接受。当事人在举证期限内提交证据材料确有困难的，可以在期限届满前申请延长举证期限。是否延长，由仲裁庭决定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）当事人未能在规定的期限内提交证据，或虽提交证据但不足以证明其主张的，负有举证责任的当事人承担因此产生的后果。</span>
      </p>
      <p>
        <span style="line-height: 142%;  font-size: 16px;"><br/></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十六条 质证</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">一</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">开庭审理的案件，证据应在开庭时出示，当事</span><span
          style=" font-size: 16px;">人可以质证。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">二</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">对于书面审理的案件的证据材料，或对于开庭</span><span
          style=" font-size: 16px;">后提交的证据材料且当事人同意书面质证的，可以进行书面质证。书面质证时，当事人应在仲裁庭规定的期限内提交书面质证意见。</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十七条 仲裁庭调查取证</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（一）仲裁庭认为必要时，可以调查事实，收集证据。</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">二</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">仲裁庭调查事实、收集证据时，可以通知当事</span><span
          style=" font-size: 16px;">人到场。经通知，一方或双方当事人不到场的，不影响仲裁庭调查事实和收集证据。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">三</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">仲裁庭调查收集的证据，应转交当事人，给予</span><span
          style=" font-size: 16px;">当事人提出意见的机会。</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十八条 专家报告及鉴定报告</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁庭可以就案件中的专门问题向专家咨询或指定鉴定人进行鉴定。专家和鉴定人可以是中国或外国的机构或自然人。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁庭有权要求当事人、当事人也有义务向专家或鉴定人提供或出示任何有关资料、文件或财产、实物， 以供专家或鉴定人审阅、检验或鉴定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）专家报告和鉴定报告的副本应转交当事人，给予当事人提出意见的机会。一方当事人要求专家或鉴定人参加开庭的，经仲裁庭同意，专家或鉴定人应参加开庭，并在仲裁庭认为必要时就所作出的报告进行解释。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第四十九条 合并开庭</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">为实现仲裁的公平、经济和快捷，如果两个或多个仲裁案件涉及相同的事实或法律问题，在征求各方当事人意见后，仲裁庭经商仲裁委员会可以决定对两个或多个仲裁案件合并开庭，并可以决定：</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）一个案件当事人提交的文件可以提交给另一个案件当事人；</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）一个案件中提交的证据可以在另一个案件中被接受和采纳，但是必须给予所有当事人对这些证据发表意见的机会。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十条 程序中止</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）双方当事人共同或分别请求中止仲裁程序，或出现其他需要中止仲裁程序的情形的，仲裁程序可以中止。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）中止程序的原因消失或中止程序期满后，仲裁程序恢复进行。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）仲裁程序的中止及恢复，由仲裁庭决定；仲裁庭尚未组成的，由仲裁委员会仲裁院院长决定。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十一条 撤回申请和撤销案件</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）当事人可以撤回全部仲裁请求或全部仲裁反请求。申请人撤回全部仲裁请求的，不影响仲裁庭就被申请人的仲裁反请求进行审理和裁决。被申请人撤回全部仲裁反请求的，不影响仲裁庭就申请人的仲裁请求进行审理和裁决。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）因当事人自身原因致使仲裁程序不能进行的， 可以视为其撤回仲裁请求。</span>
      </p>
      <p style="text-indent:2em;">
        <span
          style="font-size: 16px;">（三）仲裁请求和反请求全部撤回的，案件可以撤销。在仲裁庭组成前撤销案件的，由仲裁委员会仲裁院院长作出撤案决定；仲裁庭组成后撤销案件的，由仲裁庭作出撤案决定。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）上述第（三）款及本规则第六条第（七）款所述撤案决定应加盖“中国海事仲裁委员会”印章。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十二条 仲裁与调解相结合</span>
      </p>

      <p style="text-indent:2em;">
        <span
          style=" font-size: 16px;">（一）双方当事人有调解愿望的，或一方当事人有调解愿望并经仲裁庭征得另一方当事人同意的，仲裁庭可以在仲裁程序中对案件进行调解。双方当事人也可以自行和解。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁庭在征得双方当事人同意后可以按照其认为适当的方式进行调解。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）调解过程中，任何一方当事人提出终止调解或仲裁庭认为已无调解成功的可能时，仲裁庭应终止调解。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（四）双方当事人经仲裁庭调解达成和解或自行和解的，应签订和解协议。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（五）当事人经调解达成或自行达成和解协议的，可以撤回仲裁请求或反请求，也可以请求仲裁庭根据当事人和解协议的内容作出裁决书或制作调解书。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（六）当事人请求制作调解书的，调解书应当写明仲裁请求和当事人书面和解协议的内容，由仲裁员署名，并加盖“中国海事仲裁委员会”印章，送达双方当事人。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（七）调解不成功的，仲裁庭应当继续进行仲裁程序并作出裁决。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（八）当事人有调解愿望但不愿在仲裁庭主持下进行调解的，经双方当事人同意，仲裁委员会可以协助当事人以适当的方式和程序进行调解。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（九）如果调解不成功，任何一方当事人均不得在其后的仲裁程序、司法程序和其他任何程序中援引对方当事人</span>
      </p>

      <p>
        <span style=" font-size: 16px;">或仲裁庭在调解过程中曾发表的意见、提出的观点、作出的陈述、表示认同或否定的建议或主张作为其请求、答辩或反请求的依据。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（十）当事人在仲裁程序开始之前自行达成或经调解达成和解协议的，可以依据由仲裁委员会仲裁的仲裁协议及其和解协议，请求仲裁委员会组成仲裁庭，按照和解协议的内容作出仲裁裁决。除非当事人另有约定，仲裁委员会秘书长指定一名独任仲裁员成立仲裁庭，由仲裁庭按照其认为适当的程序进行审理并作出裁决。具体程序和期限，不受本规则其他条款关于程序和期限的限制。</span>
      </p>


      <p style="text-align:center">
        <span style="font-size: 16px;"><span style=" font-size: 16px;font-weight: 700;">第三章</span> <span
          style="font-weight: 700; font-size: 16px;">裁决</span></span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十三条 作出裁决的期限</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（一）仲裁庭应在组庭后 6 个月内作出裁决书。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）经仲裁庭请求，仲裁委员会仲裁院院长认为确有正当理由和必要的，可以延长该期限。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）程序中止的期间不计入上述第（一）款规定的裁决期限。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十四条 裁决的作出</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁庭应当根据事实和合同约定，依照法律规定，参考国际惯例，公平合理、独立公正地作出裁决。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">二</span><span style=" font-size: 16px;">）当事人对于案件实体适用法有约定的，从其约</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">定。当事人没有约定或其约定与法律强制性规定相抵触的，</span> <span
          style="font-size: 16px;">由仲裁庭决定案件实体的法律适用。</span></span></span>
      </p>
      <p style=";text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（三</span><span
          style=" letter-spacing: -2px; font-size: 16px;">）</span><span
          style=" font-size: 16px;">仲裁庭在裁决书中，应写明仲裁请求、争议事实、</span><span style=" font-size: 16px;">裁决理由、裁决结果、仲裁费用的承担、裁决的日期和地点。</span><span
          style=" font-size: 16px;">当事人协议不写明争议事实和裁决理由的，以及按照双方当事人和解协议的内容作出裁决书的，可以不写明争议事实和裁决理由。仲裁庭有权在裁决书中确定当事人履行裁决的具体期限及逾期履行所应承担的责任。</span></span>
      </p>
      <p>
        <span style=" font-size: 16px;">（四）裁决书应加盖“中国海事仲裁委员会”印章。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（五）由三名仲裁员组成的仲裁庭审理的案件，裁决依全体仲裁员或多数仲裁员的意见作出。少数仲裁员的书面意见应附卷，并可以附在裁决书后，该书面意见不构成裁决书的组成部分。</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">六</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">仲裁庭不能形成多数意见的，裁决依首席仲裁</span><span
          style=" font-size: 16px;">员的意见作出。其他仲裁员的书面意见应附卷，并可以附在裁决书后，该书面意见不构成裁决书的组成部分。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（七）除非裁决依首席仲裁员意见或独任仲裁员意见</span><span
          style=" font-size: 16px;">作出并由其署名，裁决书应由多数仲裁员署名。持有不同意见的仲裁员可以在裁决书上署名，也可以不署名。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（八）作出裁决书的日期，即为裁决发生法律效力的日期。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">九</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">裁决是终局的，对双方当事人均有约束力。任</span><span
          style=" font-size: 16px;">何一方当事人均不得向法院起诉，也不得向其他任何机构提出变更仲裁裁决的请求。</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十五条 &nbsp;部分裁决</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁庭认为必要或当事人提出请求并经仲裁庭同意的，仲裁庭可以在作出最终裁决之前，就当事人的某些请求事项先行作出部分裁决。部分裁决是终局的，对双方当事人均有约束力。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）一方当事人不履行部分裁决，不影响仲裁程序的继续进行，也不影响仲裁庭作出最终裁决。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十六条 裁决书草案的核阅</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">仲裁庭应在签署裁决书之前将裁决书草案提交仲裁委员会核阅。在不影响仲裁庭独立裁决的情况下，仲裁委员会可以就裁决书的有关问题提请仲裁庭注意。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十七条 费用承担</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁庭有权在裁决书中裁定当事人最终应向仲裁委员会支付的仲裁费和其他费用。</span>
      </p>
      <p>
        <span style=" font-size: 16px;">（二）仲裁庭有权根据案件的具体情况在裁决书中裁</span>
      </p>

      <p>
        <span style="font-size: 16px;"><span style=" font-size: 16px;">定败诉方应补偿胜诉方因办理案件而支出的合理的费用。仲裁庭裁定败诉方补偿胜诉方因办理案件而支出的费用是否合理时，应具体考虑案件的裁决结果、复杂程度、胜诉方当事</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">人及</span> /</span><span
          style=" letter-spacing: -4px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;">或代理人的实际工作量以及案件的争议金额等因素。</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十八条 裁决书的更正</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁庭可以在发出裁决书后的合理时间内自行以书面形式对裁决书中的书写、打印、计算上的错误或其他类似性质的错误作出更正。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）任何一方当事人均可以在收到裁决书后 30 天内就裁决书中的书写、打印、计算上的错误或其他类似性质的错误，书面申请仲裁庭作出更正；如确有错误，仲裁庭应在收到书面申请后 30 天内作出书面更正。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）上述书面更正构成裁决书的组成部分，应适用本规则第五十四条第（四）至（九）款的规定。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第五十九条 补充裁决</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）如果裁决书中有遗漏事项，仲裁庭可以在发出裁决书后的合理时间内自行作出补充裁决。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）任何一方当事人可以在收到裁决书后 30 天内以书面形式请求仲裁庭就裁决书中遗漏的事项作出补充裁决； 如确有漏裁事项，仲裁庭应在收到上述书面申请后 30 天内作出补充裁决。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）该补充裁决构成裁决书的一部分，应适用本规则第五十四条第（四）至（九）款的规定。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十条 裁决的履行</span>
      </p>

      <p style=";text-indent:2em;">
        <span style=" font-size: 16px;">（一）当事人应依照裁决书写明的期限履行仲裁裁决； 裁决书未写明履行期限的，应立即履行。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）一方当事人不履行裁决的，另一方当事人可以依法向有管辖权的法院申请执行。</span>
      </p>
      <p style="text-align: center;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;font-weight: 700;">第四章</span> <span
          style="font-weight: 700;font-size: 16px;">简易程序</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十一条 简易程序的适用</span>
      </p>
      <p style="text-indent:2em;text-align:justify;text-justify:inter-ideograph;">
        <span style=" font-size: 16px;">（一）除非当事人另有约定，凡争议金额不超过人民币 200 万元的，或争议金额超过人民币 200 万元但经一方当事人书面申请并征得另一方当事人书面同意的，或双方当事人约定适用简易程序的，适用简易程序。</span>
      </p>
      <p style="text-indent:2em;text-align:justify;text-justify:inter-ideograph;">
        <span style=" font-size: 16px;">（二）没有争议金额或者争议金额不明确的，由仲裁委员会根据案件的复杂程度、涉及利益的大小以及其他有关因素综合考虑决定是否适用简易程序。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十二条 仲裁通知</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">申请人提出仲裁申请，经审查可以受理并适用简易程序的，仲裁委员会仲裁院应向双方当事人发出仲裁通知。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十三条 仲裁庭的组成</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">除非当事人另有约定，适用简易程序的案件，依照本规则第三十二条的规定成立独任仲裁庭审理案件。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十四条 答辩和反请求</span>
      </p>
      <p style="text-indent:2em;text-align:justify;text-justify:inter-ideograph;">
        <span
          style=" font-size: 16px;">（一）被申请人应在收到仲裁通知后 20 天内提交答辩书及证据材料以及其他证明文件；如有反请求，也应在此期限内提交反请求书及证据材料以及其他证明文件。</span>
      </p>
      <p style="text-indent:2em;text-align:justify;text-justify:inter-ideograph;">
        <span style=" font-size: 16px;">（二）申请人应在收到反请求书及其附件后 20 天内针对被申请人的反请求提交答辩。</span>
      </p>
      <p style="text-indent:2em;text-align:justify;text-justify:inter-ideograph;">
        <span style=" font-size: 16px;">（三）当事人确有正当理由请求延长上述期限的，由仲裁庭决定是否延长；仲裁庭尚未组成的，由仲裁委员会仲裁院作出决定。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十五条 审理方式</span>
      </p>
      <p style="text-indent:2em;text-align:justify;text-justify:inter-ideograph;">
        <span style=" font-size: 16px;">仲裁庭可以按照其认为适当的方式审理案件，可以在征求当事人意见后决定只依据当事人提交的书面材料和证据进行书面审理，也可以决定开庭审理。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十六条 开庭通知</span>
      </p>
      <p style="text-indent:2em;text-align:justify;text-justify:inter-ideograph;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">一</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">对于开庭审理的案件，仲裁庭确定第一次开庭</span><span
          style=" font-size: 16px;"><span style="font-size: 16px;">日期后，应不晚于开庭前</span> </span><span
          style=" font-size: 16px;">15</span><span style=" font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">天将开庭日期通知双方当事人。当事人有正当理由的，可以请求延期开庭，但应于收到开庭</span><span style=" font-size: 16px;"><span
          style="font-size: 16px;">通知后</span> </span><span style=" font-size: 16px;">3</span><span
          style=" font-size: 16px;">&nbsp;<span style="font-size: 16px;">天内提出书面延期申请；是否延期，由仲裁庭决定。</span></span></span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（</span><span
          style=" font-size: 16px;">二</span><span style=" font-size: 16px;">）</span><span style=" font-size: 16px;">当事人有正当理由未能按上述第</span><span
          style=" font-size: 16px;">（</span><span style=" font-size: 16px;">一</span><span
          style=" font-size: 16px;">）款规定</span><span style=" font-size: 16px;">提出延期开庭申请的，是否接受其延期申请，由仲裁庭决定。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）再次开庭审理的日期及延期后开庭审理日期的通知及其延期申请，不受上述第（一）款期限的限制。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十七条 作出裁决的期限</span>
      </p>
      <p>
        <span style=" font-size: 16px;">（一）仲裁庭应在组庭后 3 个月内作出裁决书。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）经仲裁庭请求，仲裁委员会仲裁院院长认为确有正当理由和必要的，可以延长该期限。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）程序中止的期间不计入上述第（一）款规定的裁决期限。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十八条 程序变更</span>
      </p>

      <p style="text-indent:2em;text-align:justify;text-justify:inter-ideograph;">
        <span style=" font-size: 16px;">仲裁请求的变更或反请求的提出，不影响简易程序的继续进行。经变更的仲裁请求或反请求所涉争议金额分别超过人民币 200 万元的案件，除非当事人约定或仲裁庭认为有必要变更为普通程序，继续适用简易程序。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第六十九条 本规则其他条款的适用</span>
      </p>

      <p>
        <span style=" font-size: 16px;">本章未规定的事项，适用本规则其他各章的有关规定。</span>
      </p>


      <p style="text-align: center;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;font-weight: 700;">第五章</span> <span
          style="font-weight: 700;font-size: 16px;">香港仲裁的特别规定</span></span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十条 本章的适用</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）仲裁委员会在香港特别行政区设立仲裁委员会香港仲裁中心。本章适用于仲裁委员会香港仲裁中心接受仲裁申请并管理的仲裁案件。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）当事人约定将争议提交仲裁委员会香港仲裁中心仲裁或约定将争议提交仲裁委员会在香港仲裁的，由仲裁委员会香港仲裁中心接受仲裁申请并管理案件。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十一条 仲裁地及程序适用法</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">除非当事人另有约定，仲裁委员会香港仲裁中心管理的案件的仲裁地为香港，仲裁程序适用法为香港仲裁法，仲裁裁决为香港裁决。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十二条 管辖权决定的作出</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">当事人对仲裁协议及/ 或仲裁案件管辖权的异议，应不晚于第一次实体答辩前提出。仲裁庭有权对仲裁协议的存在、效力以及仲裁案件的管辖权作出决定。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十三条 仲裁员的选定或指定</span>
      </p>

      <p style="text-indent:2em;">
        <span
          style=" font-size: 16px;">仲裁委员会现行仲裁员名册在仲裁委员会香港仲裁中心管理的案件中推荐使用，当事人可以在仲裁委员会仲裁员名册外选定仲裁员。被选定的仲裁员应经仲裁委员会秘书长确认。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十四条 临时措施和紧急救济</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（一）除非当事人另有约定，应一方当事人申请，仲裁庭有权决定采取适当的临时措施。</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）在仲裁庭组成之前，当事人可以按照《中国海事仲裁委员会紧急仲裁员程序》（本规则附件三）申请紧急性临时救济。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十五条 裁决书的印章</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">裁决书应加盖“中国海事仲裁委员会香港仲裁中心” 印章。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十六条 仲裁收费</span>
      </p>

      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">依本章接受申请并管理的案件适用《中国海事仲裁委员会仲裁费用表（二）》（本规则附件二）。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十七条 本规则其他条款的适用</span>
      </p>

      <p>
        <span style=" font-size: 16px;">本章未规定的事项，适用本规则其他各章的有关规定。</span>
      </p>
      <p style="text-align:center">
        <span style="font-size: 16px;"><span style=" font-size: 16px;font-weight: 700;">第六章</span> <span
          style="font-weight: 700;font-size: 16px;">附则</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十八条 仲裁语言</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（一）当事人对仲裁语言有约定的，从其约定。当事人对仲裁语言没有约定的，以中文为仲裁语言。仲裁委员会也可以视案件的具体情形确定其他语言为仲裁语言。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）仲裁庭开庭时，当事人或其代理人、证人需要语言翻译的，可由仲裁委员会仲裁院提供译员，也可由当事人自行提供译员。</span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（三）当事人提交的各种文书和证明材料，仲裁庭或仲裁委员会仲裁院认为必要时，可以要求当事人提供相应的中文译本或其他语言译本。</span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第七十九条 仲裁费用及实际费用</span>
      </p>

      <p style=";text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（一）仲裁委员会除按照制定的仲裁费用表向当事人</span><span
          style=" font-size: 16px;">收取仲裁费外，还可以向当事人收取其他额外的、合理的实</span><span style=" font-size: 16px;">际费用，包括仲裁员办理案件的特殊报酬、差旅费、食宿费、</span><span
          style=" font-size: 16px;">聘请速录员速录费，以及仲裁庭聘请专家、鉴定人和翻译等费用。仲裁员的特殊报酬由仲裁委员会仲裁院在征求相关仲裁员和当事人意见后，参照《中国海事仲裁委员会仲裁费用</span><span
          style=" letter-spacing: -3px; font-size: 16px;">表</span><span style=" font-size: 16px;">（二</span><span
          style=" letter-spacing: -3px; font-size: 16px;">）</span><span style=" letter-spacing: -7px; font-size: 16px;">》</span><span
          style=" font-size: 16px;">（本规则附件二</span><span style=" letter-spacing: -3px; font-size: 16px;">）</span><span
          style=" font-size: 16px;">有关仲裁员报酬和费用标准确定。</span></span>
      </p>
      <p style="text-indent:2em;">
        <span style=" font-size: 16px;">（二）当事人未在仲裁委员会规定的期限内为其选定的仲裁员预缴特殊报酬、差旅费、食宿费等实际费用的，视为没有选定仲裁员。</span>
      </p>
      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;"><span
          style="font-size: 16px;">（三）当事人约定在仲裁委员会或其分会</span> </span><span style=" font-size: 16px;">/</span><span
          style=" letter-spacing: -3px; font-size: 16px;">&nbsp;</span><span style=" font-size: 16px;">仲裁中心</span><span
          style=" font-size: 16px;">所在地之外开庭的，应预缴因此而发生的差旅费、食宿费等</span><span style=" font-size: 16px;">实际费用。当事人未在仲裁委员会规定的期限内预缴有关实际费用的，应在仲裁委员会或其分会</span><span
          style=" font-size: 16px;">/</span><span style=" letter-spacing: -5px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">仲裁中心所在地开庭。</span></span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;">（四）当事人约定以两种或两种以上语言为仲裁语言</span><span
          style=" font-size: 16px;">的，或根据本规则第六十一的规定适用简易程序的案件但当事人约定由三人仲裁庭审理的，仲裁委员会可以向当事人收取额外的、合理的费用。</span></span>
      </p>
      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第八十条 &nbsp;规则的解释</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（一）本规则条文标题不用于解释条文含义。</span>
      </p>

      <p>
        <span style=" font-size: 16px;">（二）本规则由仲裁委员会负责解释。</span>
      </p>

      <p style="font-weight: bold;">
        <span style=" font-size: 16px;">第八十一条 规则的施行</span>
      </p>

      <p style="text-indent:2em;">
        <span style="font-size: 16px;"><span style=" font-size: 16px;"><span
          style="font-size: 16px;">本规则自</span> </span><span style=" font-size: 16px;">2018 年 10 月 1 </span><span
          style=" font-size: 16px;">日起施行。本规则施行前仲</span><span style=" font-size: 16px;"><span style="font-size: 16px;">裁委员会及其分会</span> /</span><span
          style=" letter-spacing: -3px; font-size: 16px;">&nbsp;</span><span
          style=" font-size: 16px;">仲裁中心管理的案件，仍适用受理案件</span><span
          style=" font-size: 16px;">时适用的仲裁规则；双方当事人同意的，也可以适用本规则。</span></span>
      </p>
      <p>
        <span style="font-size: 16px;"><br/></span>
      </p>
      <p>
        <br/>
      </p>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'guide',
    data() {
      return {
        type: 'line'
      }
    }
  }
</script>

<style lang="scss" scoped>
  h4 {
    text-align: center;
    padding: 6px 0;
    font-weight: bold;
  }

  h5 {
    font-weight: bold;
    text-align: center;
    padding: 6px 0;
    font-size: 18px;
  }

  h6 {
    font-weight: bold;
    padding: 12px 0 2px;
  }

  p {
    font-size: 14px;
    text-indent: 2em;
    line-height: 28px;
  }

  .xianxia {
    margin-top: 30px;
    p {
      line-height: 2;
      margin: 16px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/guide/components/rule.vue